const styles = window.styles;
class WindowsPanel {
  constructor() {
    this.buyingJourney = document.querySelector("buying-journey");
    this.skipAstragalStep = false;
    this.aluminiumBifold = this;
    this.buyingJourneyApi = this.buyingJourney.buyingJourneyApi;
    this.finishStepAt = 10;
    this.CONTAINER_WIDTH = 500;
    this.CONTAINER_HEIGHT = 500;
    this.CONTAINER_WIDTH_MM = 3000;
    this.CONTAINER_HEIGHT_MM = 3000;
    this.GAP = 10; // Gap between rectangles
    // Dispatch the change event immediately after setting up the event listener

    //Object holding the information for whole Buying Journey.
    this.buyingJourneyObject = {
      id: null,
      title: null,
      panelInfo: { panelWidth: null, panelHeight: null, style: null },
      panelSize: {
        value: null,
        variantId: null,
        totalPrice: 0,
        quantity: 1,
        panelImage: null,
        stackingDirection: null,
      },
      panelProfileType: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelOutsideColour: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelInsideColour: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelHandle: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelGlass: { value: null, variantId: null, quantity: 1, totalPrice: 0 },

      trickleVents: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      profileAddons: {
        left: null,
        leftPrice: 0,
        right: null,
        rightPrice: 0,
        top: null,
        topPrice: 0,
        value: null,
      },
      postCode: { value: null },
      cill: { value: null, totalPrice: 0, variantId: null, quantity: 1 },
      accessIssue: { value: null, orderNote: null },
      gtAccessQoute: {
        firstName: null,
        lastName: null,
        mobile: null,
        email: null,
      },
      totalPrice: 0,
      invoiceUrl: null,
    };

    // step functions that will perform calculation based on selection in previous steps
    this.stepActions = {
      0: () =>
        this.getWindowSize(
          this.buyingJourneyObject,
          this.buyingJourney.querySelectorAll(".step-size input")
        ),
      1: this.calculatePanelSize.bind(this),
      2: this.getWindowStyle.bind(this),
      3: this.getWindowConfiguration.bind(this),
      4: this.getProfileType.bind(this),
      5: this.getOutsideColor.bind(this),
      6: this.getInsideColor.bind(this),
      7: this.getPanelHandle.bind(this),
      8: this.getGlassType.bind(this),
      9: this.getCill.bind(this),
      10: this.getTrickleVents.bind(this),
      11: this.setPostCode.bind(this),
      // 11: this.getpostcode.bind(this),
      12: this.getGatewayAccessQuote.bind(this),
      13: this.buyingJourney.handleAddMoreProducts.bind(this.buyingJourney),
      14: this.buyingJourney.readyQuoteOverview.bind(this.buyingJourney),
    };
  }

  connectedCallback() {
    this.render();
  }

  render() { }

  /**
   * Display error message in a popup modal
   * @param {string} message - The error message to display
   * @param {string} title - Optional title for the popup (default: 'Invalid Selection')
   */
  showErrorPopup(message, title = "Invalid Selection") {
    // Remove existing popup if any
    const existingPopup = document.getElementById("windows-error-popup");
    if (existingPopup) {
      existingPopup.remove();
    }

    // Create popup modal
    const popup = document.createElement("div");
    popup.id = "windows-error-popup";
    popup.className = "windows-error-popup-overlay";

    popup.innerHTML = `
      <div class="windows-error-popup-content">
        <div class="windows-error-popup-header">
          <h3>${title}</h3>
          <button class="windows-error-popup-close" aria-label="Close">&times;</button>
        </div>
        <div class="windows-error-popup-body">
          <div class="windows-error-popup-icon">⚠️</div>
          <p>${message}</p>
        </div>
        <div class="windows-error-popup-footer">
          <button class="windows-error-popup-btn">OK</button>
        </div>
      </div>
    `;

    // Append to document
    document.body.appendChild(popup);

    // Close handlers
    const closePopup = () => {
      popup.style.animation = "fadeOut 0.2s ease-out";
      setTimeout(() => {
        popup.remove();
      }, 200);
    };

    popup
      .querySelector(".windows-error-popup-close")
      .addEventListener("click", closePopup);
    popup
      .querySelector(".windows-error-popup-btn")
      .addEventListener("click", closePopup);
    popup.addEventListener("click", (e) => {
      if (e.target === popup) closePopup();
    });
  }

  //First step assign event listener to input fields
  getWindowSize(productObject, inputs) {
    console.log("Windows:Panel width and height");
    inputs.forEach((input) => {
      if (input.name == "panel-width") {
        input.value = productObject.panelInfo.panelWidth;
      }
      if (input.name == "panel-height") {
        input.value = productObject.panelInfo.panelHeight;
      }

      this.validateInput(productObject, input)
        ? this.buyingJourney.setActiveNextButton()
        : this.buyingJourney.setDisableNextButton();
      input.addEventListener("input", () =>
        this.validateInput(productObject, input)
          ? this.buyingJourney.setActiveNextButton()
          : this.buyingJourney.setDisableNextButton()
      );
      input.dispatchEvent(this.buyingJourney.changeEvent);
    });
  }

  //Based on added width and height calcualte the Panel Style for Step 2
  calculatePanelSize() {
    if (this.buyingJourneyObject.panelInfo.style != null) {
      const styleInput = document.querySelector(
        `input[name="windows:-style"][value="${this.buyingJourneyObject.panelInfo.style}"]`
      );
      if (styleInput) styleInput.checked = true;
      styleInput.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.disableUnfitVariants();
    this.setupOptionListeners('input[name="windows:-style"]');
  }

  // Step 3
  getWindowStyle() {
    console.log("Window configuration");
    this.CONTAINER_WIDTH_MM = parseInt(
      this.buyingJourneyObject.panelInfo.panelWidth,
      10
    );
    this.CONTAINER_HEIGHT_MM = parseInt(
      this.buyingJourneyObject.panelInfo.panelHeight,
      10
    );
    const canvasContainer = document.querySelector(
      ".window-configuration-wrapper"
    );

    // Make the container width 100% of the canvas container and keep the ratio with the height
    if (canvasContainer) {
      const canvasContainerRect = canvasContainer.getBoundingClientRect();
      const canvasContainerWidth = canvasContainerRect.width;

      // Calculate the aspect ratio from the original panel dimensions
      const aspectRatio = this.CONTAINER_HEIGHT_MM / this.CONTAINER_WIDTH_MM;

      // Set container width to 100% of canvas container
      this.CONTAINER_WIDTH = canvasContainerWidth - 70;

      // Calculate height based on aspect ratio to maintain proportions
      this.CONTAINER_HEIGHT = this.CONTAINER_WIDTH * aspectRatio;

      // Apply minimum size constraints if needed
      const minSize = 300; // Minimum size for usability
      if (this.CONTAINER_WIDTH < minSize) {
        this.CONTAINER_WIDTH = minSize - 70;
        this.CONTAINER_HEIGHT = this.CONTAINER_WIDTH * aspectRatio;
      }

      // Apply maximum size constraints to prevent overflow
      const maxSize = 800;
      if (this.CONTAINER_WIDTH > maxSize) {
        this.CONTAINER_WIDTH = maxSize - 70;
        this.CONTAINER_HEIGHT = this.CONTAINER_WIDTH * aspectRatio;
      }

      // Ensure height doesn't exceed reasonable bounds
      const maxHeight = 600;
      if (this.CONTAINER_HEIGHT > maxHeight) {
        this.CONTAINER_HEIGHT = maxHeight;
        this.CONTAINER_WIDTH = this.CONTAINER_HEIGHT / aspectRatio;
      }
    }

    const selectedStyle =
      this.buyingJourney.querySelector(
        'input[name="windows:-style"]:checked'
      ) ||
      document.querySelector(
        `input[name="windows:-style"][value="${this.buyingJourneyObject.panelInfo.style}"]`
      );
    if (selectedStyle) {
      this.buyingJourneyObject.panelInfo.style = selectedStyle.value || "";
    }

    const windowStyle = selectedStyle.value.replace(" ", "").toLowerCase();
    if (!this.buyingJourneyObject.panelInfo.oldStyleName)
      this.buyingJourneyObject.panelInfo.oldStyleName =
        this.buyingJourneyObject.panelInfo.styleName || "";
    this.buyingJourneyObject.panelInfo.styleName = windowStyle;

    this.getSelectedProduct(
      selectedStyle.value.replace(" ", "-").toLowerCase(),
      this.CONTAINER_WIDTH_MM,
      this.CONTAINER_HEIGHT_MM
    );

    // Get the image of the selected style
    const selectedStyleImage = selectedStyle
      .closest("label")
      .querySelector("img").src;
    this.buyingJourneyObject.panelInfo.image = selectedStyleImage;

    const container = document.querySelector("#gridContainer");
    // const svg = this.createSvgBody(windowStyle);
    // container.innerHTML = svg;
    const def = this.getConfStyle(windowStyle); // or any 'styleX' key

    this.generateGridLayout(def, container);
    this.buyingJourney.setActiveNextButton();
    // console.log(this.buyingJourneyObject);
  }

  //Step 4
  getWindowConfiguration() {
    console.log("Profile Type");
    this.getCurrentStyleDimensions();

    if (this.buyingJourneyObject.panelProfileType.variantId != null) {
      const selectedProfileType = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelProfileType.variantId +
        '"]'
      );
      selectedProfileType.checked = true;
      selectedProfileType.dispatchEvent(this.buyingJourney.changeEvent);
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="windows:-profile-type"]');
  }

  //Step 5: show outside colour and get profile type
  getProfileType() {
    console.log("Outside Colour");
    if (this.buyingJourneyObject.panelOutsideColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelOutsideColour.variantId +
        '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedProfileType = this.buyingJourney.querySelector(
      'input[name="windows:-profile-type"]:checked'
    );

    if (selectedProfileType) {
      this.buyingJourneyObject.panelProfileType.value =
        selectedProfileType.value || null;
      this.buyingJourneyObject.panelProfileType.variantId =
        selectedProfileType.dataset.variantId || null;
      this.buyingJourneyObject.panelProfileType.totalPrice = this.convertPrice(
        selectedProfileType.dataset.price
      );
    }

    document
      .querySelectorAll('input[name="windows:_outside_colour"]')
      .forEach((colourItem) => {
        colourItem.addEventListener("change", function () { });
      });
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="windows:_outside_colour"]');
  }

  //Step 6: show inside colour and get selected outside colour
  getOutsideColor() {
    console.log("Outside Colour");
    const colorOptions = {
      "Anthracite Grey": ["White", "Anthracite Grey"],
      Black: ["White", "Black"],
      White: ["White"],
    };

    if (this.buyingJourneyObject.panelInsideColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelInsideColour.variantId +
        '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    let selectedOutsideColor = this.buyingJourney.querySelector(
      'input[name="windows:_outside_colour"]:checked'
    );
    if (!selectedOutsideColor)
      selectedOutsideColor = this.buyingJourney.querySelector(
        `input[data-variant-id="${this.buyingJourneyObject.panelOutsideColour.variantId}"]`
      );

    this.buyingJourney
      .querySelectorAll('input[name="windows:_inside_colour"]')
      .forEach((insideColour) => {
        const availableColors = colorOptions[selectedOutsideColor?.value];
        if (availableColors.includes(insideColour.value)) {
          insideColour.closest(".panel-wrapper").classList.remove("hidden");
        } else {
          insideColour.closest(".panel-wrapper").classList.add("hidden");
          insideColour.checked = false;
        }
      });

    if (selectedOutsideColor) {
      this.buyingJourneyObject.panelOutsideColour.value =
        `${selectedOutsideColor.value} ( ${selectedOutsideColor.dataset.ralvalue} )` ||
        null;
      this.buyingJourneyObject.panelOutsideColour.variantId =
        selectedOutsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelOutsideColour.totalPrice =
        this.convertPrice(selectedOutsideColor.dataset.price);
      this.buyingJourneyObject.panelOutsideColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="windows:_inside_colour"]');
  }

  //Step 7: Show Handles and get the selected inside colours
  getInsideColor() {
    console.log("Handles");

    const selectedInsideColor = this.buyingJourney.querySelector(
      'input[name="windows:_inside_colour"]:checked'
    );

    if (selectedInsideColor) {
      this.buyingJourneyObject.panelInsideColour.value =
        `${selectedInsideColor.value} ( ${selectedInsideColor.dataset.ralvalue} )` ||
        null;
      this.buyingJourneyObject.panelInsideColour.variantId =
        selectedInsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelInsideColour.totalPrice = this.convertPrice(
        selectedInsideColor.dataset.price
      );
      this.buyingJourneyObject.panelInsideColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    if (this.buyingJourneyObject.panelHandle.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelHandle.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    this.setupOptionListeners('input[name="windows:-handles"]');
  }

  //Step 8: show glass sizes and get the selected handles
  getPanelHandle() {
    const glassSize =
      (this.buyingJourneyObject.panelInfo.panelWidth / 1000) *
      (this.buyingJourneyObject.panelInfo.panelHeight / 1000);
    const glassSizeOptions = this.buyingJourney.querySelectorAll(
      'input[name="windows:-glass_size"]'
    );
    const classInstance = this;
    glassSizeOptions.forEach((radio) => {
      radio.addEventListener("change", function () {
        checkForSelectedGlass(this);
      });

      if (radio && radio.dataset.variantPrice > 0) {
        const totalGlassPrice = Math.round(
          parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize
        );
        radio.dataset.price = totalGlassPrice;
        const panelPriceElement = radio
          .closest(".panel-wrapper")
          .querySelector(".panel-price");
        if (panelPriceElement) {
          panelPriceElement.innerHTML =
            totalGlassPrice === 0
              ? '<span class="free-badge">Free included </span>'
              : "+£" + totalGlassPrice;
        }
      }
    });

    const selectedGlass = this.buyingJourney.querySelector(
      'input[name="windows:-glass_size"]:checked'
    );

    if (selectedGlass) {
      checkForSelectedGlass(selectedGlass);
    }

    const selectedHandle = this.buyingJourney.querySelector(
      'input[name="windows:-handles"]:checked'
    );

    if (selectedHandle) {
      this.buyingJourneyObject.panelHandle.value = selectedHandle.value || null;
      this.buyingJourneyObject.panelHandle.variantId =
        selectedHandle.dataset.variantId || null;
      this.buyingJourneyObject.panelHandle.totalPrice = this.convertPrice(
        selectedHandle.dataset.price
      );
    }

    if (this.buyingJourneyObject.panelGlass.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelGlass.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.setupOptionListeners('input[name="windows:-glass_size"]');

    function checkForSelectedGlass(radio) {
      if (
        radio.value.includes("standard-low-e-tough-1.2-u-value") ||
        radio.value.includes("tough-ultra-low-e-1.1u") ||
        radio.value.includes("tough-solar-control-1-u-value")
      ) {
        classInstance.buyingJourney.nextStepButton.dataset.increment = 0;
      }
    }
    console.log(this.buyingJourneyObject);
  }

  updateGlassValues() {
    const selectedGlass = this.buyingJourney.querySelector(
      'input[name="windows:-glass_size"]:checked'
    );

    if (selectedGlass) {
      this.buyingJourneyObject.panelGlass.value = selectedGlass.value;
      this.buyingJourneyObject.panelGlass.variantId =
        selectedGlass.dataset.variantId;
      const pricePerSqm = selectedGlass.dataset.variantPrice * 100;
      const totalPrice =
        pricePerSqm * this.buyingJourneyObject.panelInfo.summary.totalSqm;
      this.buyingJourneyObject.panelGlass.totalPrice =
        this.convertPrice(totalPrice) / 100;
    }
  }

  // Step 9
  getGlassType() {
    console.log("Cill");

    this.updateGlassValues(); // make sure we have the latest glass values

    if (this.buyingJourneyObject.cill.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.cill.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
    this.setupOptionListeners('input[name="windows:-cills"]');
    console.log(this.buyingJourneyObject);
  }

  // Step 10
  getCill() {
    console.log("Trickle Vents");

    if (this.buyingJourneyObject.trickleVents.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.trickleVents.variantId +
        '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedCill = this.buyingJourney.querySelector(
      'input[name="windows:-cills"]:checked'
    );

    if (selectedCill) {
      this.buyingJourneyObject.cill.value = selectedCill.value;
      this.buyingJourneyObject.cill.variantId = selectedCill.dataset.variantId;
      this.buyingJourneyObject.cill.totalPrice = this.convertPrice(
        selectedCill.dataset.price *
        this.buyingJourneyObject.panelInfo.summary.totalLinearMeters
      );
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="windows:-trickle-vent"]');
  }

  // Step 11
  getTrickleVents() {
    console.log("Profile Addons");

    const selectedTrickleOption = this.buyingJourney.querySelector(
      'input[name="windows:-trickle-vent"]:checked'
    );
    if (selectedTrickleOption) {
      this.buyingJourneyObject.trickleVents.value = selectedTrickleOption.value;
      this.buyingJourneyObject.trickleVents.variantId =
        selectedTrickleOption.dataset.variantId;
      this.buyingJourneyObject.trickleVents.totalPrice = this.convertPrice(
        selectedTrickleOption.dataset.price
      );
    }

    const isAddonsNotRequired = this.buyingJourney.querySelector(
      'input[name="addons_notRequired"]'
    );
    isAddonsNotRequired.addEventListener("change", () => {
      this.getAddonProfile(isAddonsNotRequired.checked);
    });
    isAddonsNotRequired.dispatchEvent(this.buyingJourney.changeEvent);

    console.log(this.buyingJourneyObject);
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
  }

  getAddonProfile(isAddonsNotRequired) {
    this.updateGlassValues(); // make sure we have the latest glass values
    const left_side = this.buyingJourney.querySelector(
      'select[name="left_side"]'
    );
    const right_side = this.buyingJourney.querySelector(
      'select[name="right_side"]'
    );
    const top_side = this.buyingJourney.querySelector(
      'select[name="top_side"]'
    );
    const classInstance = this;
    setDisableforAddonprofiles();

    if (isAddonsNotRequired == false) {
      console.log("Addons Required");

      if (left_side) {
        let selectedLeftFrameLength =
          left_side.options[left_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.left =
          this.buyingJourneyObject.profileAddons.left || "0mm";
        left_side.addEventListener("change", () => {
          selectedLeftFrameLength = left_side.options[left_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.left =
            selectedLeftFrameLength.value;
          this.buyingJourneyObject.profileAddons.leftPrice = this.convertPrice(
            selectedLeftFrameLength.dataset.price *
            (this.buyingJourneyObject.panelInfo.panelHeight / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (right_side) {
        let selectedRightFrameLength =
          right_side.options[right_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.right =
          this.buyingJourneyObject.profileAddons.right || "0mm";
        right_side.addEventListener("change", () => {
          selectedRightFrameLength =
            right_side.options[right_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.right =
            selectedRightFrameLength.value;
          this.buyingJourneyObject.profileAddons.rightPrice = this.convertPrice(
            selectedRightFrameLength.dataset.price *
            (this.buyingJourneyObject.panelInfo.panelHeight / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (top_side) {
        let selectedTopFrameLength = top_side.options[top_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.top =
          this.buyingJourneyObject.profileAddons.top || "0mm";
        top_side.addEventListener("change", () => {
          selectedTopFrameLength = top_side.options[top_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.top =
            selectedTopFrameLength.value;
          this.buyingJourneyObject.profileAddons.topPrice = this.convertPrice(
            selectedTopFrameLength.dataset.price *
            (this.buyingJourneyObject.panelInfo.panelWidth / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (this.buyingJourneyObject.profileAddons.left != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'select[name="left_side"]'
        );
        selectedOption.value = this.buyingJourneyObject.profileAddons.left;
        // selectedOption.dispatchEvent(this.buyingJourney.changeEvent)
      }

      if (this.buyingJourneyObject.profileAddons.right != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'select[name="right_side"]'
        );
        selectedOption.value = this.buyingJourneyObject.profileAddons.right;
      }

      if (this.buyingJourneyObject.profileAddons.top != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'select[name="top_side"]'
        );
        selectedOption.value = this.buyingJourneyObject.profileAddons.top;
        //selectedOption.dispatchEvent(changeEvent)
      }

      this.buyingJourneyObject.profileAddons.value = "Required";
    } else {
      this.buyingJourneyObject.profileAddons = {};
      this.buyingJourneyObject.profileAddons.value = "Not Required";
      this.buyingJourneyObject.profileAddons.left = "0mm";
      this.buyingJourneyObject.profileAddons.leftPrice = 0;
      this.buyingJourneyObject.profileAddons.top = "0mm";
      this.buyingJourneyObject.profileAddons.topPrice = 0;
      this.buyingJourneyObject.profileAddons.right = "0mm";
      this.buyingJourneyObject.profileAddons.rightPrice = 0;
    }

    function setDisableforAddonprofiles() {
      if (
        isAddonsNotRequired == false &&
        (left_side.value == "no" ||
          right_side.value == "no" ||
          top_side.value == "no")
      ) {
        classInstance.buyingJourney.setDisableNextButton();
      } else {
        classInstance.buyingJourney.setActiveNextButton();
      }
    }
    if (Object.keys(this.buyingJourney.personDetails).length > 0) {
      this.buyingJourneyObject.gtAccessQoute.firstName =
        this.buyingJourney.personDetails.firstName;
      this.buyingJourneyObject.gtAccessQoute.lastName =
        this.buyingJourney.personDetails.lastName;
      this.buyingJourneyObject.gtAccessQoute.email =
        this.buyingJourney.personDetails.email;
      this.buyingJourneyObject.gtAccessQoute.mobile =
        this.buyingJourney.personDetails.phone;
      this.buyingJourneyObject.postCode.value =
        this.buyingJourney.personDetails.postcode;
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  setPostCode() {
    console.log("PostCode");

    this.updateGlassValues(); // make sure we have the latest glass values

    if (this.buyingJourneyObject.postCode.value != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="post-code"]'
      );
      selectedOption.value = this.buyingJourneyObject.postCode.value;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    let classInstance = this;
    const postCodeOptions = this.buyingJourney.querySelector(
      'input[name="post-code"]'
    );
    const postCodeInputs = [postCodeOptions];
    this.disableNextButtonOnEmptyInput(postCodeInputs);

    if (postCodeOptions) {
      postCodeOptions.addEventListener("change", () => {
        classInstance.buyingJourneyObject.postCode.value =
          postCodeOptions.value;
        this.disableNextButtonOnEmptyInput(postCodeInputs);
      });
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  getpostcode() {
    console.log("Access Issues");
    const accessIssuesOptions = this.buyingJourney.querySelectorAll(
      'input[name="delivery_access_issues"]'
    );
    this.buyingJourney.setDisableNextButton();
    if (accessIssuesOptions) {
      accessIssuesOptions.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.buyingJourney.setDisableNextButton();
          const selectedAccessIssue = this.buyingJourney.querySelector(
            'input[name="delivery_access_issues"]:checked'
          );
          this.buyingJourneyObject.accessIssue.value =
            selectedAccessIssue.value;
          const accessIssueNote = this.buyingJourney.querySelector(
            'textarea[name="access_issues_order_note"]'
          );
          if (this.buyingJourneyObject.accessIssue.value == "Yes") {
            accessIssueNote.addEventListener("change", () => {
              this.buyingJourney.setDisableNextButton();
              this.buyingJourneyObject.accessIssue.orderNote =
                accessIssueNote.value;
              if (
                this.buyingJourneyObject.accessIssue.value == "Yes" &&
                this.buyingJourneyObject.accessIssue.orderNote != null &&
                this.buyingJourneyObject.accessIssue.orderNote.trim() !== ""
              ) {
                this.buyingJourney.setActiveNextButton();
              }
            });
          } else if (this.buyingJourneyObject.accessIssue.value == "No") {
            accessIssueNote.value = null;
            this.buyingJourneyObject.accessIssue.orderNote = null;
            if (
              this.buyingJourneyObject.accessIssue.value == "No" &&
              this.buyingJourneyObject.accessIssue.orderNote == null
            ) {
              this.buyingJourney.setActiveNextButton();
            }
          }
        });
      });
      if (this.buyingJourneyObject.accessIssue.value != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'input[name="delivery_access_issues"][value="' +
          this.buyingJourneyObject.accessIssue.value +
          '"]'
        );
        selectedOption.checked = true;
        if (this.buyingJourneyObject.accessIssue.value == "Yes") {
          this.buyingJourney.querySelector(
            'input[name="access_issues_order_note"]'
          ).value = this.buyingJourneyObject.accessIssue.orderNote;
        }
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
  }

  //Gate access
  getGatewayAccessQuote() {
    console.log("Gateway Access");
    if (this.buyingJourneyObject.gtAccessQoute.firstName != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[firstName]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.firstName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.lastName != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[lastName]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.lastName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.email != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[email]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.email;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    if (this.buyingJourneyObject.gtAccessQoute.mobile != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[phone]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.mobile;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const accessQuoteInputs =
      this.buyingJourney.querySelectorAll(".step-gtaq input");
    this.disableNextButtonOnEmptyInput(accessQuoteInputs);
    accessQuoteInputs.forEach((input) => {
      input.addEventListener("change", () => {
        switch (input.name) {
          case "contact[firstName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.firstName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.firstName = null;
            }
            break;
          case "contact[lastName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.lastName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.lastName = null;
            }
            break;
          case "contact[phone]":
            {
              const IsValidFormat = this.buyingJourney.validateAndFormatPhone(
                input.value,
                "GB"
              );
              console.log("Is phone number is valid? " + IsValidFormat.valid);
              if (input.value.length == 11 && IsValidFormat.valid) {
                this.buyingJourneyObject.gtAccessQoute.mobile = input.value;
                input.classList.remove("invalid");
              } else {
                this.buyingJourneyObject.gtAccessQoute.mobile = null;
                input.classList.add("invalid");
              }
            }
            break;
          case "contact[email]":
            if (this.buyingJourney.validateEmail()) {
              console.log("valid Email");
              this.buyingJourneyObject.gtAccessQoute.email = input.value;
            } else {
              console.log("Invalid Email");
              this.buyingJourneyObject.gtAccessQoute.email = null;
            }
            break;
          default:
            console.log("no input");
            break;
        }

        if (
          this.buyingJourneyObject.gtAccessQoute.firstName &&
          this.buyingJourneyObject.gtAccessQoute.lastName &&
          this.buyingJourneyObject.gtAccessQoute.mobile &&
          this.buyingJourneyObject.gtAccessQoute.email
        ) {
          this.buyingJourney.setActiveNextButton();
        } else {
          this.buyingJourney.setDisableNextButton();
        }
      });
    });
  }

  getProductFinalPrice() {
    this.buyingJourneyObject.totalPrice = Math.round(
      this.convertPrice(
        this.buyingJourneyObject.cill.totalPrice +
        this.buyingJourneyObject.panelGlass.totalPrice +
        this.buyingJourneyObject.panelHandle.totalPrice +
        this.buyingJourneyObject.panelInfo.price +
        this.buyingJourneyObject.panelInfo.summary.totalOpenersCost +
        this.buyingJourneyObject.panelOutsideColour.totalPrice +
        this.buyingJourneyObject.panelProfileType.totalPrice +
        this.buyingJourneyObject.profileAddons.leftPrice +
        this.buyingJourneyObject.profileAddons.rightPrice +
        this.buyingJourneyObject.profileAddons.topPrice +
        this.buyingJourneyObject.trickleVents.totalPrice
      )
    );
    return this.buyingJourneyObject.totalPrice;
  }

  collectProductData() {
    const productData = {
      title: `Window ${this.buyingJourneyObject.panelInfo.panelWidth}x${this.buyingJourneyObject.panelInfo.panelHeight} - ${this.buyingJourneyObject.panelInfo.style}`,
      handle: "your-order-" + this.buyingJourney.generateRandomSixDigitNumber(),
      body_html: `
        <p style="text-align: left;"><strong>Access Issues: </strong> ${this.buyingJourneyObject.accessIssue.value == "No"
          ? this.buyingJourneyObject.accessIssue.value
          : this.buyingJourneyObject.accessIssue.orderNote
        }</p>
        <p style="text-align: left;"><strong>Manufacturing Size: </strong> ${this.buyingJourneyObject.panelInfo.panelWidth +
        "x" +
        this.buyingJourneyObject.panelInfo.panelHeight
        }</p>
        <p style="text-align: left; font-size: 1.2rem;"><strong>Panels: </strong> </p>
        ${this.buyingJourneyObject.panelInfo.panelDimensions.map(
          (dimension) => `<p style="text-align: left;"><strong>${dimension.id
            }: </strong> 
          <br>
          <span >Width: ${Math.round(
              dimension.width * this.CONTAINER_WIDTH_MM
            )}mm</span>
          <br>
          <span >Height: ${Math.round(
              dimension.height * this.CONTAINER_HEIGHT_MM
            )}mm</span>
          <br>
          <span >Opener: ${dimension.opener}</span>
          
          </p>`
        )}
        <p style="text-align: left;"><strong> Colour: </strong> ${this.buyingJourneyObject.panelOutsideColour.value
        }</p>
        <p style="text-align: left;"><strong>Panel Profile Type: </strong> ${this.buyingJourneyObject.panelProfileType.value
        }</p>
        <p style="text-align: left;"><strong>Cill: </strong>${this.buyingJourneyObject.cill.value
        }</p>
        <p style="text-align: left;"><strong>Glass: </strong>${this.buyingJourneyObject.panelGlass.value
        }</p>
        <p style="text-align: left;"><strong>Handle Colour: </strong>${this.buyingJourneyObject.panelHandle.value
        }</p>
        <p style="text-align: left;"><strong>Trickle Vents: </strong>${this.buyingJourneyObject.trickleVents.value
        }</p>
        <p style="text-align: left;"><strong>Top Addon: </strong>${this.buyingJourneyObject.profileAddons.top
        }</p>
        <p style="text-align: left;"><strong>Right Addon: </strong>${this.buyingJourneyObject.profileAddons.right
        }</p>
        <p style="text-align: left;"><strong>Left Addon: </strong>${this.buyingJourneyObject.profileAddons.left
        }</p>
        <p style="text-align: left;"><strong>Hinge Colour: </strong>Black</p>



        <p style="text-align: left;"><strong>Total price:</strong> £${this.getProductFinalPrice()} </p>
        `,
      vendor: "NOW Aluminium",
      product_type: "quote-product",
      variants: [
        {
          price: this.getProductFinalPrice(),
        },
      ],
      images: [
        {
          src: this.buyingJourneyObject.panelInfo.image, // Assuming this is the URL to the product image
        },
      ],
      properties: this.getProductProperties(),
    };
    return productData;
  }

  //Helper Functions

  validateInput(productObject, input) {
    const { buyingJourney } = this;
    if (input) {
      switch (input.name) {
        case "panel-width":
          productObject.panelInfo.panelWidth = parseInt(input.value, 10) || 0;
          this.CONTAINER_WIDTH_MM = parseInt(
            productObject.panelInfo.panelWidth,
            10
          );
          this.CONTAINER_WIDTH =
            parseInt(productObject.panelInfo.panelWidth, 10) / 5;
          break;
        case "panel-height":
          productObject.panelInfo.panelHeight = parseInt(input.value, 10) || 0;
          this.CONTAINER_HEIGHT_MM = parseInt(
            productObject.panelInfo.panelHeight,
            10
          );
          this.CONTAINER_HEIGHT =
            parseInt(productObject.panelInfo.panelHeight, 10) / 5;
        default:
          break;
      }
      var isValid = true;
      const value = parseInt(input.value, 10);
      if (!isNaN(value)) {
        isValid = true;
        if (input.hasAttribute("min") && input.hasAttribute("max")) {
          isValid = value >= input.min && value <= input.max;
        }
      }
      input.classList.toggle("invalid", !isValid);
      if (input.parentElement.nextElementSibling) {
        input.parentElement.nextElementSibling.classList.toggle(
          "show",
          !isValid
        );
      }
      if (this.validateStep()) {
        return true;
      } else {
        return false;
      }
    }
  }

  setIncrementForButtons(selectedFitting, triggerStepNumber = null) {
    const selectedFittingdowncased = selectedFitting.toLowerCase();
    switch (selectedFittingdowncased) {
      case "yes":
        this.buyingJourney.unskipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 0;
        break;
      case "no":
        this.buyingJourney.skipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 2;
        break;
      default:
        // do nothing
        break;
    }
  }

  setDecrementForButtons(selectedFitting) {
    const { buyingJourney } = this;
    switch (selectedFitting) {
      case "yes":
        this.buyingJourney.prevStepButton.dataset.decrement = 0;
        break;
      case "no":
        this.buyingJourney.prevStepButton.dataset.decrement = 2;
        break;
      case "skipAstragal":
        this.buyingJourney.prevStepButton.dataset.decrement = 3;
        break;
      default:
        // do nothing
        break;
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  validateStep() {
    const activeInputs = this.buyingJourney.querySelectorAll(
      ".step-container.active input"
    );
    return Array.from(activeInputs).every(
      (input) => input && input.value && !input.classList.contains("invalid")
    );
  }

  setupOptionListeners(selector) {
    const options = this.buyingJourney.querySelectorAll(selector);
    options.forEach((option) =>
      option.addEventListener("change", () => {
        if (option) option.checked = true;
        this.disableNextButtonOnNonSelection(options);
      })
    );
    this.disableNextButtonOnNonSelection(options);
  }

  disableNextButtonOnNonSelection(options) {
    const anyChecked = Array.from(options).some(
      (option) => option && option.checked
    );
    if (anyChecked) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  convertPrice(price) {
    let priceRounded;
    if (price) {
      let decimalPrice = parseFloat(price); // Convert the price to a float
      priceRounded = Math.round(decimalPrice * 100.0) / 100; // Multiply by 100, round, then divide by 100
    } else {
      priceRounded = 0;
    }
    return priceRounded;
  }

  disableNextButtonOnEmptyInput(inputs) {
    const allFilled = Array.from(inputs).every(
      (input) => input && input.value.trim() !== ""
    );
    let classInstance = this;
    if (allFilled) {
      classInstance.buyingJourney.setActiveNextButton();
    } else {
      classInstance.buyingJourney.setDisableNextButton();
    }
  }

  getProductProperties() {
    const openerOptions = {
      "top-opener": "Top Hinged",
      "left-opener": "Right Hinged",
      "right-opener": "Left Hinged",
      dummy: "Dummy",
      fixed: "Fixed",
    };
    const opener = this.buyingJourneyObject.panelInfo.panelDimensions
      .map(
        (dimension) => `${dimension.text}: ${openerOptions[dimension.opener]}`
      )
      .join(", ");
    const windowDimensions = this.buyingJourneyObject.panelInfo.panelDimensions
      .map(
        (dimension) =>
          `${dimension.text}: ${dimension.width_MM}mm x ${dimension.height_MM}mm`
      )
      .join(" , ");
    return {
      "First name": `${this.buyingJourneyObject.gtAccessQoute.firstName}`,
      "Last name": `${this.buyingJourneyObject.gtAccessQoute.lastName}`,
      Email: `${this.buyingJourneyObject.gtAccessQoute.email}`,
      Phone: `${this.buyingJourneyObject.gtAccessQoute.mobile}`,
      Postcode: `${this.buyingJourneyObject.postCode}`,
      "Panel width": `${this.buyingJourneyObject.panelInfo.panelWidth}`,
      "Panel height": `${this.buyingJourneyObject.panelInfo.panelHeight}`,
      style: this.buyingJourneyObject.panelInfo.style,
      "Panel outside color": `${this.buyingJourneyObject.panelOutsideColour.value}`,
      "Panel inside color": `${this.buyingJourneyObject.panelInsideColour.value}`,
      "Panel handle": `${this.buyingJourneyObject.panelHandle.value}`,
      "Panel glass": `${this.buyingJourneyObject.panelGlass.value}`,
      "Trickle vents": `${this.buyingJourneyObject.trickleVents.value}`,
      "Panel profile type": `${this.buyingJourneyObject.panelProfileType.value}`,
      "Profile addons": `${this.buyingJourneyObject.profileAddons.value}`,
      "Profile addons top": `${this.buyingJourneyObject.profileAddons.top}`,
      "Profile addons right": `${this.buyingJourneyObject.profileAddons.right}`,
      "Profile addons left": `${this.buyingJourneyObject.profileAddons.left}`,
      Postcode: `${this.buyingJourneyObject.postCode.value}`,
      Cill: `${this.buyingJourneyObject.cill.value}`,
      "Product type": "windows",
      "Access issues": `${this.buyingJourneyObject.accessIssue.value}`,
      "Access issues note": `${this.buyingJourneyObject.accessIssue.orderNote}`,
      "Panel image": `${this.buyingJourneyObject.panelInfo.image}`,
      "Verified Email": `${this.buyingJourney.emailVerified}`,
      "window dimensions": `${windowDimensions}`,
      Opener: opener,
      _buyingJourneyObject: this.buyingJourney.TokenUtils.encode(this.buyingJourneyObject),

    };
  }

  convertOrderItemsIntoProductObject(orderItem) {
    console.log("convert Order items into Product");
    const props = orderItem.properties || {};

    let _buyingJourneyObject = null;
    if (props["_buyingJourneyObject"]) {
      if (!props["_buyingJourneyObject"].includes("{")) {
        _buyingJourneyObject = this.buyingJourney.TokenUtils.decode(props["_buyingJourneyObject"]);
      } else {
        _buyingJourneyObject = JSON.parse(props["_buyingJourneyObject"]);
      }
    }
    this.buyingJourneyObject.id = orderItem.id;
    this.buyingJourneyObject.product_id = orderItem.product_id;
    this.buyingJourneyObject.title = orderItem.title.replace(
      " - Variant 1",
      ""
    );
    this.buyingJourneyObject.totalPrice = orderItem.price;
    this.buyingJourneyObject.panelInfo.image =
      orderItem.image || orderItem.properties["Panel image"];
    this.buyingJourneyObject.panelInfo.panelWidth =
      orderItem.properties["Panel width"];
    this.buyingJourneyObject.panelInfo.panelHeight =
      orderItem.properties["Panel height"];
    this.buyingJourneyObject.panelInfo.windowDimensions =
      orderItem.properties["window dimensions"];
    this.buyingJourneyObject.panelInfo.style =
      orderItem.properties["Panel style"];
    this.buyingJourneyObject.panelInfo.styleName = orderItem.properties[
      "Panel style"
    ]?.replace(" ", "");
    this.buyingJourneyObject.panelProfileType.value =
      orderItem.properties["Panel profile type"];
    this.buyingJourneyObject.opener = orderItem.properties["Opener"];
    this.buyingJourneyObject.panelOutsideColour.value =
      orderItem.properties["Panel outside color"];
    this.buyingJourneyObject.panelInsideColour.value =
      orderItem.properties["Panel inside color"];

    // this.buyingJourneyObject.panelInsideColour.value = orderItem.properties['Panel inside color'];

    this.buyingJourneyObject.panelHandle.value =
      orderItem.properties["Panel handle"];

    this.buyingJourneyObject.panelGlass.value =
      orderItem.properties["Panel glass"];

    this.buyingJourneyObject.trickleVents.value =
      orderItem.properties["Trickle vents"];

    this.buyingJourneyObject.profileAddons.left =
      orderItem.properties["Profile addons left"];
    this.buyingJourneyObject.profileAddons.right =
      orderItem.properties["Profile addons right"];
    this.buyingJourneyObject.profileAddons.top =
      orderItem.properties["Profile addons top"];
    this.buyingJourneyObject.profileAddons.value =
      orderItem.properties["Profile addons"];

    this.buyingJourneyObject.postCode.value = orderItem.properties["Postcode"];

    this.buyingJourneyObject.cill.value = orderItem.properties["Cill"];

    this.buyingJourneyObject.accessIssue.value =
      orderItem.properties["Access issues"];
    this.buyingJourneyObject.accessIssue.orderNote =
      orderItem.properties["Access issues note"];

    this.buyingJourneyObject.gtAccessQoute.firstName =
      orderItem.properties["First name"];
    this.buyingJourneyObject.gtAccessQoute.lastName =
      orderItem.properties["Last name"];
    this.buyingJourneyObject.gtAccessQoute.mobile =
      orderItem.properties["Phone"];
    this.buyingJourneyObject.gtAccessQoute.email =
      orderItem.properties["Email"];
    this.buyingJourneyObject.productType = "windows";

    this.buyingJourneyObject._buyingJourneyObject = _buyingJourneyObject;


    const productObject = JSON.parse(JSON.stringify(this.buyingJourneyObject));
    console.log("productObject", productObject);

    return productObject;
  }
  // Create individual quote item element
  createQuoteItemElement(item) {
    const { buyingJourney } = this;
    const diemssions = item._buyingJourneyObject.panelInfo;
    const div = document.createElement("div");
    div.className = "bj-cart-bottom";
    div.innerHTML = `
    <div class="bj-cart-bottom-right-top accordion-toggle">
      <div class="cart-accor-header-left">
        <h2 class="bj-cart-heading accordion-toggle">${item.title}</h2>
        <div class="bj-cart-total-price">
          <span class="bj-cart-price" data-price="${item.totalPrice
      }" data-order-price>${Shopify.formatMoney(item.totalPrice)}</span>
          <span class="bj-cart-price-text">+ VAT</span>
        </div>
      </div>
      <div class="cart-accor-header-right">
        <a class="bj-cart-image-text removeQuoteProduct" data-item-id="${item.id
      }" data-product-id="${item.product_id}">
          <span>Remove</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="21.8047" y="0.199219" width="21.601" height="21.601" rx="10.8005" transform="rotate(90 21.8047 0.199219)" fill="#967b50"/>
            <path d="M8.45014 7.98345L14.0186 7.98345L14.0186 13.5519M13.6319 8.37015L7.9861 14.016" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <button type="button" class="accordion-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
              <rect y="0.224609" width="28" height="28" rx="14" fill="#967b50"></rect>
              <path d="M7.51465 15.8193L13.9999 9.33398L20.4852 15.8193" stroke="#f1f1f1" stroke-width="1.64706" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </button>
      </div>
    </div>
    <div class="bj-cart-bottom-in">
      <div class="bj-cart-bottom-in-left">
        <div class="cart-item-image" id="gridContainer">
          ${this.createOverviewSvg(diemssions)}
        </div>
      </div>
      <div class="bj-cart-bottom-in-right">
        <div class="bj-cart-bottom-right-center">
          <h3 class="bj-cart-detail-heading">Your Window</h3>
          <div class="bj-cart-details">
            ${buyingJourney.renderDetail(
        "Manufacturing size (mm)",
        `${item.panelInfo.panelWidth} x ${item.panelInfo.panelHeight}`,
        "step-1",
        1
      )}
            ${buyingJourney.renderDetail(
        "Opener",
        `${item.opener}`,
        "step-3",
        3
      )}
            ${buyingJourney.renderDetail(
        "Outside colour",
        item.panelOutsideColour.value,
        "step-5",
        5
      )}
            ${buyingJourney.renderDetail(
        "Inside colour",
        item.panelInsideColour.value,
        "step-6",
        6
      )}
            ${buyingJourney.renderDetail(
        "Top addon",
        item.profileAddons.top,
        "step-10",
        11
      )}
            ${buyingJourney.renderDetail(
        "Handle colour",
        item.panelHandle.value,
        "step-6",
        7
      )}
            ${buyingJourney.renderDetail(
        "Left addon",
        item.profileAddons.left,
        "step-10",
        11
      )}
            ${buyingJourney.renderDetail(
        "Panel profile type",
        item.panelProfileType.value,
        "step-4",
        4
      )}
              ${buyingJourney.renderDetail(
        "Trickle vents",
        item.trickleVents.value,
        "step-9",
        10
      )}
            ${buyingJourney.renderDetail(
        "Hinge colour",
        "Black",
        "",
        "hinge-color"
      )}
            ${buyingJourney.renderDetail(
        "Right addon",
        item.profileAddons.right,
        "step-10",
        11
      )}
            ${buyingJourney.renderDetail(
        "Glass",
        item.panelGlass.value,
        "step-7",
        8
      )}
            ${buyingJourney.renderDetail(
        "Cill",
        item.cill.value === "null" ? "No" : item.cill.value,
        "step-8",
        9
      )}
            ${buyingJourney.renderDetail(
        "Delivery",
        "Standard",
        "",
        "order-delivery"
      )}
            ${buyingJourney.renderDetail(
        "Window Dimensions",
        item.panelInfo.windowDimensions,
        "",
        3
      )}

          </div>
        </div>
      </div>
    </div>
  `;

    // Attach remove handler
    div
      .querySelector(".removeQuoteProduct")
      ?.addEventListener("click", () =>
        buyingJourney.removeQuoteProduct(item.id, item.product_id)
      );
    div.querySelectorAll(".edit-option")?.forEach((option) =>
      option.addEventListener("click", () => {
        this.editHandler(option, item);
      })
    );
    return div;
  }

  generateGridLayout(def, container) {
    const configHeader = document.querySelector(
      ".configuration-wrapper-header"
    );
    const dimensionWrap = document.querySelector(".configuration-dimension");
    const { panelInfo } = this.buyingJourneyObject;
    const fragmentHead = document.createDocumentFragment();
    const svg = this.createSvgBody(def.name);
    container.innerHTML = svg;
    this.moveInputsIntoTop(container);
    configHeader.innerHTML = "";

    // --- DIMENSIONS INFO ---
    dimensionWrap.innerHTML = `
        <span><b>Width:</b>  ${panelInfo.panelWidth}</span>
        <span><b>Height:</b> ${panelInfo.panelHeight}</span>`;

    // const openerOptions = [
    //   "Fixed",
    //   "Top Opener",
    //   "Left Opener",
    //   "Right Opener",
    //   "Dummy",
    // ];
    const openerOptions = [
      {
        label: "Fixed",
        value: "fixed",
      },
      {
        label: "Top Hinged",
        value: "top-opener",
      },
      {
        label: "Right Hinged",
        value: "left-opener",
      },
      {
        label: "Left Hinged",
        value: "right-opener",
      },
      {
        label: "Dummy",
        value: "dummy",
      },
    ];
    // 1) Header: .plan-wrapper → <select>
    def.layout.forEach((rect) => {
      const wrapper = document.createElement("div");
      wrapper.className = "plan-wrapper";

      const openerOptionsHtml = openerOptions
        .map((option) => {
          const isSelected = rect.controllers.opener === option.value;
          return `<option ${isSelected ? "selected" : ""} value="${option.value
            }">${option.label}</option>`;
        })
        .join("");

      wrapper.innerHTML = `
          <div class="plan-label">Pane ${rect.text}</div>
          <div class="plan-select-wrapper">
            <select class="plan-select svg-embedded-select" data-pane-id="${rect.id}">
              ${openerOptionsHtml}
            </select>
          </div>`;

      fragmentHead.appendChild(wrapper);
    });

    configHeader.appendChild(fragmentHead);

    this.setupEmbeddedInputListeners();
  }

  createBorderLines(selectedPane) {
    const blueBox = selectedPane.querySelector(".pane-inner");
    const svg = selectedPane.querySelector("#arrowOverlay");
    const borderBox = blueBox.parentElement;

    const blueRect = blueBox.getBoundingClientRect();
    const borderRect = borderBox.getBoundingClientRect();

    // Convert global (viewport) coordinates to SVG-relative
    function toSVGCoords(x, y) {
      return {
        x: x - borderRect.left,
        y: y - borderRect.top,
      };
    }

    // Blue box corners (relative to viewport)
    const blueCorners = {
      topLeft: toSVGCoords(blueRect.left, blueRect.top),
      topRight: toSVGCoords(blueRect.right, blueRect.top),
      bottomLeft: toSVGCoords(blueRect.left, blueRect.bottom),
      bottomRight: toSVGCoords(blueRect.right, blueRect.bottom),
    };

    // Border box outer corners
    const borderCorners = {
      topLeft: { x: 0, y: 0 },
      topRight: { x: borderRect.width, y: 0 },
      bottomLeft: { x: 0, y: borderRect.height },
      bottomRight: { x: borderRect.width, y: borderRect.height },
    };

    // Clear previous lines
    svg.innerHTML = "";

    function drawLine(x1, y1, x2, y2) {
      const line = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "line"
      );
      line.setAttribute("x1", x1);
      line.setAttribute("y1", y1);
      line.setAttribute("x2", x2);
      line.setAttribute("y2", y2);
      line.setAttribute("stroke", "black");
      line.setAttribute("stroke-width", "1");
      svg.appendChild(line);
    }

    drawLine(
      blueCorners.topLeft.x,
      blueCorners.topLeft.y,
      borderCorners.topLeft.x,
      borderCorners.topLeft.y
    );
    drawLine(
      blueCorners.topRight.x,
      blueCorners.topRight.y,
      borderCorners.topRight.x,
      borderCorners.topRight.y
    );
    drawLine(
      blueCorners.bottomLeft.x,
      blueCorners.bottomLeft.y,
      borderCorners.bottomLeft.x,
      borderCorners.bottomLeft.y
    );
    drawLine(
      blueCorners.bottomRight.x,
      blueCorners.bottomRight.y,
      borderCorners.bottomRight.x,
      borderCorners.bottomRight.y
    );
  }

  getLetterDirection(areas, targetLetter) {
    const positions = [];

    // Find all positions of the target letter
    areas.forEach((row, rowIndex) => {
      row.forEach((letter, colIndex) => {
        if (letter === targetLetter) {
          positions.push({ row: rowIndex, col: colIndex });
        }
      });
    });

    if (positions.length === 0) return null; // Letter not found

    const uniqueRows = new Set(positions.map((p) => p.row));
    const uniqueCols = new Set(positions.map((p) => p.col));

    if (uniqueRows.size === 1) return "width"; // All in same row
    if (uniqueCols.size === 1) return "height"; // All in same column
    return "height"; // Mixed case or scattered
  }

  /**
   * Get the configuration style for a given window style
   * Supports default dimensions in millimeters via defaultHeightMM and defaultWidthMM properties
   *
   * @param {string} windowStyle - The name of the window style
   * @returns {Object} The style configuration with layout definitions
   *
   * Layout items can specify default dimensions in millimeters:
   * - defaultHeightMM: Sets the default height in millimeters (converted to relative value 0-1)
   * - defaultWidthMM: Sets the default width in millimeters (converted to relative value 0-1)
   *
   * Defaults are applied only once per layout item and won't override user modifications
   */
  getConfStyle(windowStyle) {
    const style = styles.find((style) => style.name === windowStyle);
    if (
      this.buyingJourney.editOrder &&
      style.name === this.buyingJourneyObject.panelInfo.oldStyleName
    )
      style.layout = this.buyingJourneyObject.panelInfo.panelDimensions;

    // Apply default dimensions in MM if they exist (only if not already applied)
    if (style && style.layout) {
      const rectsWithDefaults = [];

      style.layout.forEach((rect) => {
        let defaultsApplied = false;

        // Apply default height in MM if specified and not already applied
        if (
          rect.defaultHeightMM &&
          this.CONTAINER_HEIGHT_MM &&
          !rect._defaultsApplied
        ) {
          rect.height = rect.defaultHeightMM / this.CONTAINER_HEIGHT_MM;
          defaultsApplied = true;
        }

        // Apply default width in MM if specified and not already applied
        if (
          rect.defaultWidthMM &&
          this.CONTAINER_WIDTH_MM &&
          !rect._defaultsApplied
        ) {
          rect.width = rect.defaultWidthMM / this.CONTAINER_WIDTH_MM;
          defaultsApplied = true;
        }

        // Mark defaults as applied and track which rects need dependency updates
        if (defaultsApplied) {
          rect._defaultsApplied = true;
          rectsWithDefaults.push(rect);
        }
      });

      // Apply dimension changes to dependent rectangles
      rectsWithDefaults.forEach((rect) => {
        this.applyDefaultDimensionChanges(style, rect);
      });
    }

    return style;
  }

  /**
   * Apply dimension changes to dependent rectangles when default dimensions are set
   * This ensures that when one rectangle has a default dimension, other related rectangles adjust accordingly
   *
   * @param {Object} style - The style configuration object
   * @param {Object} rectToUpdate - The rectangle that had default dimensions applied
   */
  applyDefaultDimensionChanges(style, rectToUpdate) {
    if (!style || !style.layout || !rectToUpdate) return;

    // Handle attached rectangles (rectangles that should have the same dimension)
    if (rectToUpdate.controllers) {
      ["width", "height"].forEach((property) => {
        const attachedProperty = `attached${property.charAt(0).toUpperCase() + property.slice(1)
          }`;

        if (rectToUpdate.controllers[attachedProperty]) {
          const attachedRectIds = rectToUpdate.controllers[attachedProperty];
          if (Array.isArray(attachedRectIds)) {
            attachedRectIds.forEach((attachedId) => {
              const attachedRect = style.layout.find(
                (rect) => rect.id === attachedId
              );
              if (attachedRect) {
                attachedRect[property] = rectToUpdate[property];
                // Also update position for attached rectangles
                if (property === "width") {
                  attachedRect.x = rectToUpdate.x;
                } else if (property === "height") {
                  attachedRect.y = rectToUpdate.y;
                }
              }
            });
          }
        }
      });
    }

    // Handle dependent rectangles (rectangles that need to adjust when this one changes)
    ["width", "height"].forEach((property) => {
      if (rectToUpdate.controllers && rectToUpdate.controllers[property]) {
        const dependentRectIds = rectToUpdate.controllers[property];
        if (Array.isArray(dependentRectIds)) {
          dependentRectIds.forEach((depId) => {
            const dependentRect = style.layout.find(
              (rect) => rect.id === depId
            );
            if (dependentRect) {
              if (property === "height") {
                // For height: find all rectangles in the same column that share space
                const sameColumnRects = style.layout.filter(
                  (rect) =>
                    Math.abs(rect.x - rectToUpdate.x) < 0.01 &&
                    rect.totalCols === rectToUpdate.totalCols
                );

                // Calculate space used by other rectangles (not the current one or the dependent one)
                let spaceUsedByOthers = 0;
                sameColumnRects.forEach((rect) => {
                  if (rect.id !== rectToUpdate.id && rect.id !== depId) {
                    spaceUsedByOthers += rect.height;
                  }
                });

                // Calculate remaining space for the dependent rectangle
                const remainingSpace =
                  1.0 - rectToUpdate.height - spaceUsedByOthers;

                // Ensure dependent rectangle doesn't become too small
                if (remainingSpace > 0.05) {
                  dependentRect.height = remainingSpace;

                  // Update position based on spatial relationship
                  if (dependentRect.y > rectToUpdate.y) {
                    // Dependent rect is below - move it down
                    dependentRect.y = rectToUpdate.y + rectToUpdate.height;
                  } else if (dependentRect.y < rectToUpdate.y) {
                    // Dependent rect is above - update current rect position
                    rectToUpdate.y = dependentRect.y + dependentRect.height;
                  }

                  // Handle attached rectangles of dependent rect
                  if (
                    dependentRect.controllers &&
                    dependentRect.controllers.attachedHeight
                  ) {
                    dependentRect.controllers.attachedHeight.forEach(
                      (attachedId) => {
                        const attachedRect = style.layout.find(
                          (rect) => rect.id === attachedId
                        );
                        if (attachedRect) {
                          attachedRect.height = dependentRect.height;
                          attachedRect.y = dependentRect.y;
                        }
                      }
                    );
                  }
                }
              } else if (property === "width") {
                // For width: find all rectangles in the same row that share space
                const sameRowRects = style.layout.filter(
                  (rect) =>
                    Math.abs(rect.y - rectToUpdate.y) < 0.01 &&
                    rect.totalRows === rectToUpdate.totalRows
                );

                // Calculate space used by other rectangles
                let spaceUsedByOthers = 0;
                sameRowRects.forEach((rect) => {
                  if (rect.id !== rectToUpdate.id && rect.id !== depId) {
                    spaceUsedByOthers += rect.width;
                  }
                });

                // Calculate remaining space for the dependent rectangle
                const remainingSpace =
                  1.0 - rectToUpdate.width - spaceUsedByOthers;

                // Ensure dependent rectangle doesn't become too small
                if (remainingSpace > 0.05) {
                  dependentRect.width = remainingSpace;

                  // Update position based on spatial relationship
                  if (dependentRect.x > rectToUpdate.x) {
                    // Dependent rect is to the right - move it right
                    dependentRect.x = rectToUpdate.x + rectToUpdate.width;
                  } else if (dependentRect.x < rectToUpdate.x) {
                    // Dependent rect is to the left - update current rect position
                    rectToUpdate.x = dependentRect.x + dependentRect.width;
                  }

                  // Handle attached rectangles of dependent rect
                  if (
                    dependentRect.controllers &&
                    dependentRect.controllers.attachedWidth
                  ) {
                    dependentRect.controllers.attachedWidth.forEach(
                      (attachedId) => {
                        const attachedRect = style.layout.find(
                          (rect) => rect.id === attachedId
                        );
                        if (attachedRect) {
                          attachedRect.width = dependentRect.width;
                          attachedRect.x = dependentRect.x;
                        }
                      }
                    );
                  }
                }
              }
            }
          });
        }
      }
    });

    // Handle combinedWidth logic - rectangles that should span multiple other rectangles
    style.layout.forEach((rect) => {
      if (rect.controllers && rect.controllers.combinedWidth) {
        const sourceRectIds = rect.controllers.combinedWidth;
        if (Array.isArray(sourceRectIds)) {
          // Get source rectangles and sort them by x position
          const sourceRects = sourceRectIds
            .map((id) => style.layout.find((r) => r.id === id))
            .filter((r) => r)
            .sort((a, b) => a.x - b.x);

          if (sourceRects.length > 0) {
            // Calculate the span from leftmost start to rightmost end
            const leftmostX = sourceRects[0].x;
            const rightmostX =
              sourceRects[sourceRects.length - 1].x +
              sourceRects[sourceRects.length - 1].width;

            // The combined width includes the rectangles AND the gaps between them
            const combinedWidth = rightmostX - leftmostX;

            // Update the rectangle with combined dimensions
            rect.width = combinedWidth;
            rect.x = leftmostX;
          }
        }
      }
    });
  }

  // new svg layout

  createSvgBody(layoutStyle = "style1") {
    const svg = `<svg width="${this.CONTAINER_WIDTH + 1}" height="${this.CONTAINER_HEIGHT + 1
      }">`;
    const rects = this.createPredefinedLayout(layoutStyle);
    const finalSvg = svg + rects.join("") + "</svg>";

    return finalSvg;
  }

  createPredefinedLayout(styleName) {
    const rects = [];

    // Helper function to create a rectangle with relative dimensions and gaps
    const createRect = (
      x,
      y,
      width,
      height,
      text,
      totalCols = 1,
      totalRows = 1,
      rowSpan = 0,
      colSpan = 0,
      colIndex = 0,
      rowIndex = 0,
      opener = "fixed", // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
      controllers = null // Add controllers parameter
    ) => {
      console.log(opener);

      // Calculate available space after accounting for gaps
      const availableWidth =
        this.CONTAINER_WIDTH - this.GAP * (totalCols - colSpan - 1);
      const availableHeight =
        this.CONTAINER_HEIGHT - this.GAP * (totalRows - rowSpan - 1);

      // Calculate absolute dimensions based on available space
      const absoluteWidth = width * availableWidth;
      const absoluteHeight = height * availableHeight;

      // Calculate position with gaps
      const absoluteX = x * availableWidth + colIndex * this.GAP;
      const absoluteY = y * availableHeight + rowIndex * this.GAP;

      // Create input controls for dimensions if controllable
      let inputControls = "";
      if (controllers) {
        const inputWidth = 53;
        const inputHeight = 23;

        if (controllers.width) {
          const widthValue = Math.round(width * this.CONTAINER_WIDTH_MM);
          inputControls += `
          <foreignObject x="${absoluteX + absoluteWidth / 2 - inputWidth / 2
            }" y="${this.CONTAINER_HEIGHT + 20
            }" width="${inputWidth}" height="${inputHeight}">
              <input type="number" 
                     min="1" 
                     max="${this.CONTAINER_WIDTH_MM}" 
                     step="1" 
                     value="${widthValue}" 
                     data-rect-id="${text}" 
                     data-property="width"
                     data-previous-value="${widthValue}"
                     style="border: 2px solid black;font-size: 13px;max-width: 45px;text-align: center;"
                     class="svg-embedded-input" />
          </foreignObject>`;
        }

        if (controllers.height) {
          const heightValue = Math.round(height * this.CONTAINER_HEIGHT_MM);
          inputControls += `
          <foreignObject x="${-60}" y="${absoluteY + absoluteHeight / 2 - inputHeight / 2
            }" width="${inputWidth}" height="${inputHeight}" >
              <input type="number" 
                     min="1" 
                     max="${this.CONTAINER_HEIGHT_MM}" 
                     step="1" 
                     value="${heightValue}" 
                     data-rect-id="${text}" 
                     data-property="height"
                     data-previous-value="${heightValue}"
                     style="border: 2px solid black;font-size: 13px;max-width: 45px;text-align: center;"
                     class="svg-embedded-input" />
          </foreignObject>`;
        }
      }

      // Always render all elements, but set dimensions to 0 for fixed elements
      const isFixed = opener === "fixed";

      // For opener elements (non-fixed), use normal dimensions
      // For fixed elements, set opener-specific dimensions to 0
      const openerWidth = isFixed ? 0 : absoluteWidth;
      const openerHeight = isFixed ? 0 : absoluteHeight;
      const contentWidth = isFixed ? 0 : absoluteWidth - 30;
      const contentHeight = isFixed ? 0 : absoluteHeight - 30;
      const mainRectWidth = isFixed ? absoluteWidth : 0;
      const mainRectHeight = isFixed ? absoluteHeight : 0;
      const mainRectStroke = isFixed ? 2 : 0;

      return `
      <!-- Main rectangle (visible for fixed elements) -->
      <rect id="rect-${text}-main" x="${absoluteX}" y="${absoluteY}" width="${mainRectWidth}" height="${mainRectHeight}" stroke="black" stroke-width="${mainRectStroke}" fill="none" />
      
      <!-- Opener rectangle (visible for non-fixed elements) -->
      <rect class="rect-opener" id="rect-${text}-opener" x="${absoluteX}" y="${absoluteY}" width="${openerWidth}" height="${openerHeight}" fill="white" stroke="black" stroke-width="${isFixed ? 0 : 1
        }" />
      
      <!-- Content rectangle (visible for non-fixed elements) -->
      <rect class="rect-content" id="rect-${text}" x="${absoluteX + 15}" y="${absoluteY + 15
        }" width="${contentWidth}" height="${contentHeight}" stroke="black" stroke-width="${isFixed ? 0 : 1
        }" fill="none" />

      <!-- Corner lines (visible for non-fixed elements) -->
      <line id="line-${text}-tl" x1="${absoluteX}" y1="${absoluteY}" x2="${absoluteX + 15
        }" y2="${absoluteY + 15}" stroke="black" stroke-width="${isFixed ? 0 : 1
        }" />
      <line id="line-${text}-bl" x1="${absoluteX}" y1="${absoluteY + absoluteHeight
        }" x2="${absoluteX + 15}" y2="${absoluteY + absoluteHeight - 15
        }" stroke="black" stroke-width="${isFixed ? 0 : 1}" />
      <line id="line-${text}-tr" x1="${absoluteX + absoluteWidth
        }" y1="${absoluteY}" x2="${absoluteX + absoluteWidth - 15}" y2="${absoluteY + 15
        }" stroke="black" stroke-width="${isFixed ? 0 : 1}" />
      <line id="line-${text}-br" x1="${absoluteX + absoluteWidth}" y1="${absoluteY + absoluteHeight
        }" x2="${absoluteX + absoluteWidth - 15}" y2="${absoluteY + absoluteHeight - 15
        }" stroke="black" stroke-width="${isFixed ? 0 : 1}" />

      <!-- Opener direction lines (only visible for specific opener types) -->
      ${opener === "top-opener"
          ? `
        <line id="line-${text}-opener-1" x1="${absoluteX + 15}" y1="${absoluteY + absoluteHeight - 15
          }" x2="${absoluteX + absoluteWidth / 2}" y2="${absoluteY + 15
          }" stroke="red" stroke-width="3" />
        <line id="line-${text}-opener-2" x1="${absoluteX + absoluteWidth - 15
          }" y1="${absoluteY + absoluteHeight - 15}" x2="${absoluteX + absoluteWidth / 2
          }" y2="${absoluteY + 15}" stroke="red" stroke-width="3" />
      `
          : `
        <line id="line-${text}-opener-1" x1="0" y1="0" x2="0" y2="0" stroke="red" stroke-width="0" />
        <line id="line-${text}-opener-2" x1="0" y1="0" x2="0" y2="0" stroke="red" stroke-width="0" />
      `
        }
      
      ${opener === "left-opener"
          ? `
        <line id="line-${text}-opener-3" x1="${absoluteX + 15}" y1="${absoluteY + absoluteHeight - 15
          }" x2="${absoluteX + absoluteWidth - 15}" y2="${absoluteY + absoluteHeight / 2
          }" stroke="red" stroke-width="3" />
        <line id="line-${text}-opener-4" x1="${absoluteX + 15}" y1="${absoluteY + 15
          }" x2="${absoluteX + absoluteWidth - 15}" y2="${absoluteY + absoluteHeight / 2
          }" stroke="red" stroke-width="3" />
      `
          : `
        <line id="line-${text}-opener-3" x1="0" y1="0" x2="0" y2="0" stroke="red" stroke-width="0" />
        <line id="line-${text}-opener-4" x1="0" y1="0" x2="0" y2="0" stroke="red" stroke-width="0" />
      `
        }
      
      ${opener === "right-opener"
          ? `
        <line id="line-${text}-opener-5" x1="${absoluteX + absoluteWidth - 15
          }" y1="${absoluteY + absoluteHeight - 15}" x2="${absoluteX + 15
          }" y2="${absoluteY + absoluteHeight / 2
          }" stroke="red" stroke-width="3" />
        <line id="line-${text}-opener-6" x1="${absoluteX + absoluteWidth - 15
          }" y1="${absoluteY + 15}" x2="${absoluteX + 15}" y2="${absoluteY + absoluteHeight / 2
          }" stroke="red" stroke-width="3" />
      `
          : `
        <line id="line-${text}-opener-5" x1="0" y1="0" x2="0" y2="0" stroke="red" stroke-width="0" />
        <line id="line-${text}-opener-6" x1="0" y1="0" x2="0" y2="0" stroke="red" stroke-width="0" />
      `
        }

      ${inputControls}
      <text x="${absoluteX + absoluteWidth / 2}" y="${absoluteY + absoluteHeight / 2
        }" text-anchor="middle" dominant-baseline="middle" fill="black" class="rect-text">${text}</text>
    `;
    };

    const style = this.getConfStyle(styleName);

    style.layout.forEach((rect) => {
      rects.push(
        createRect(
          rect.x,
          rect.y,
          rect.width,
          rect.height,
          rect.text,
          rect.totalCols || 1,
          rect.totalRows || 1,
          rect.rowSpan || 0,
          rect.colSpan || 0,
          rect.colIndex || 0,
          rect.rowIndex || 0,
          rect.controllers?.opener || "fixed",
          rect.controllers // Pass controllers object
        )
      );
    });

    return rects;
  }

  moveInputsIntoTop(svgContainer) {
    const inputs = svgContainer.querySelectorAll("foreignObject");
    inputs.forEach((input) => {
      svgContainer.querySelector("svg").appendChild(input);
    });
  }

  setupEmbeddedInputListeners() {
    // Add event listeners to embedded inputs
    const embeddedInputs = document.querySelectorAll(".svg-embedded-input");
    embeddedInputs.forEach((input) => {
      // Validate on blur (when user leaves the field)
      input.addEventListener("blur", this.handleDimensionChange.bind(this));

      // Apply changes on Enter key press
      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          input.blur(); // Trigger blur event which will validate
        }
      });
    });

    // Add event listeners to embedded selects
    const embeddedSelects = document.querySelectorAll(".svg-embedded-select");
    embeddedSelects.forEach((select) => {
      select.addEventListener("change", this.handleOpenerChange.bind(this));
    });
  }

  handleOpenerChange(event) {
    const select = event.target;
    const rectId = select.dataset.paneId;
    const openerValue = select.value;
    const CONTAINER_WIDTH_MM = this.CONTAINER_WIDTH_MM;
    const CONTAINER_HEIGHT_MM = this.CONTAINER_HEIGHT_MM;

    // Find the current style
    const currentStyle = this.getConfStyle(
      this.buyingJourneyObject.panelInfo.styleName
    );

    if (!currentStyle) return;

    // Find the rectangle to update
    const rectToUpdate = currentStyle.layout.find((rect) => rect.id === rectId);
    if (!rectToUpdate) return;

    // Calculate current dimensions in mm
    const currentWidthMM = Math.round(rectToUpdate.width * CONTAINER_WIDTH_MM);
    const currentHeightMM = Math.round(
      rectToUpdate.height * CONTAINER_HEIGHT_MM
    );

    // Check minimum size requirements for opener types
    let isValidSize = true;
    let errorMessage = "";

    if (openerValue === "top-opener") {
      if (currentWidthMM < 350 || currentHeightMM < 400) {
        isValidSize = false;
        errorMessage = `Pane ${rectToUpdate.text}: Top Opener requires minimum 350mm width and 400mm height. Current: ${currentWidthMM}mm x ${currentHeightMM}mm`;
      }
    } else if (openerValue === "left-opener") {
      if (currentWidthMM < 500 || currentHeightMM < 400) {
        isValidSize = false;
        errorMessage = `Pane ${rectToUpdate.text}: Left Opener requires minimum 500mm width and 400mm height. Current: ${currentWidthMM}mm x ${currentHeightMM}mm`;
      }
    } else if (openerValue === "right-opener") {
      if (currentWidthMM < 500 || currentHeightMM < 400) {
        isValidSize = false;
        errorMessage = `Pane ${rectToUpdate.text}: Right Opener requires minimum 500mm width and 400mm height. Current: ${currentWidthMM}mm x ${currentHeightMM}mm`;
      }
    }

    // If size is invalid, show error popup and revert to fixed
    if (!isValidSize) {
      this.showErrorPopup(errorMessage, "Opener Size Requirements");
      select.value = "fixed";

      // Update the rectangle's opener property to fixed
      if (rectToUpdate.controllers) {
        rectToUpdate.controllers.opener = "fixed";
      }
      rectToUpdate.opener = "fixed";
    } else {
      // Update the rectangle's opener property
      if (rectToUpdate.controllers) {
        rectToUpdate.controllers.opener = openerValue;
      }
      rectToUpdate.opener = openerValue;
    }

    // Update SVG attributes instead of regenerating entire SVG
    this.updateSvgElementAttributes(
      this.buyingJourneyObject.panelInfo.styleName
    );
  }
  handleDimensionChange(event) {
    const input = event.target;
    const rectId = input.dataset.rectId;
    const property = input.dataset.property;
    const inputValue = input.value.trim();
    const mmValue = parseFloat(inputValue);
    const CONTAINER_WIDTH_MM = this.CONTAINER_WIDTH_MM;
    const CONTAINER_HEIGHT_MM = this.CONTAINER_HEIGHT_MM;

    // Find the current style
    const currentStyle = this.getConfStyle(
      this.buyingJourneyObject.panelInfo.styleName
    );

    if (!currentStyle) return;

    // Find the rectangle to update
    const rectToUpdate = currentStyle.layout.find((rect) => rect.id === rectId);
    if (!rectToUpdate) return;

    // Get previous valid value from data attribute
    const previousValue = input.dataset.previousValue;

    // If field is empty or invalid, revert to previous valid value
    if (inputValue === "" || isNaN(mmValue) || mmValue <= 0) {
      input.value = previousValue;
      return;
    }

    // Convert millimeter value to relative value (0-1)
    const newValue =
      property === "width"
        ? mmValue / CONTAINER_WIDTH_MM
        : mmValue / CONTAINER_HEIGHT_MM;

    // Validate the new value (must be between 0 and 1)
    if (newValue >= 1) {
      // Revert to previous valid value if out of bounds
      input.value = previousValue;
      return;
    }

    // Find dependent rectangles and validate that the change won't make them too small
    if (rectToUpdate.controllers && rectToUpdate.controllers[property]) {
      const dependentRectIds = rectToUpdate.controllers[property];
      if (Array.isArray(dependentRectIds)) {
        for (const depId of dependentRectIds) {
          const dependentRect = currentStyle.layout.find(
            (rect) => rect.id === depId
          );
          if (dependentRect) {
            // Calculate what space would be left for the dependent rectangle
            const sameAxisRects = currentStyle.layout.filter((rect) => {
              if (property === "height") {
                return (
                  Math.abs(rect.x - rectToUpdate.x) < 0.01 &&
                  rect.totalCols === rectToUpdate.totalCols
                );
              } else {
                return (
                  Math.abs(rect.y - rectToUpdate.y) < 0.01 &&
                  rect.totalRows === rectToUpdate.totalRows
                );
              }
            });

            // Calculate space used by other rectangles (not the current one or the dependent one)
            let spaceUsedByOthers = 0;
            sameAxisRects.forEach((rect) => {
              if (rect.id !== rectToUpdate.id && rect.id !== depId) {
                spaceUsedByOthers += rect[property];
              }
            });

            // Calculate what would remain for the dependent rectangle
            const remainingSpaceForDependent =
              1.0 - newValue - spaceUsedByOthers;

            // Check if dependent rectangle would become too small (less than 5%)
            if (remainingSpaceForDependent < 0.05) {
              // Revert to previous valid value if it would make the dependent rectangle too small
              input.value = previousValue;
              return;
            }
          }
        }
      }
    }

    // Update the rectangle's property
    rectToUpdate[property] = newValue;

    // Handle attached rectangles (rectangles that should have the same dimension)
    if (rectToUpdate.controllers) {
      const attachedProperty = `attached${property.charAt(0).toUpperCase() + property.slice(1)
        }`;
      if (rectToUpdate.controllers[attachedProperty]) {
        const attachedRectIds = rectToUpdate.controllers[attachedProperty];
        if (Array.isArray(attachedRectIds)) {
          attachedRectIds.forEach((attachedId) => {
            const attachedRect = currentStyle.layout.find(
              (rect) => rect.id === attachedId
            );
            if (attachedRect) {
              attachedRect[property] = newValue;
              // Also update position for attached rectangles
              if (property === "width") {
                attachedRect.x = rectToUpdate.x;
              } else if (property === "height") {
                attachedRect.y = rectToUpdate.y;
              }
            }
          });
        }
      }
    }

    // Handle dependent rectangles if they exist
    if (rectToUpdate.controllers && rectToUpdate.controllers[property]) {
      const dependentRectIds = rectToUpdate.controllers[property];
      if (Array.isArray(dependentRectIds)) {
        dependentRectIds.forEach((depId) => {
          const dependentRect = currentStyle.layout.find(
            (rect) => rect.id === depId
          );
          if (dependentRect) {
            if (property === "height") {
              // For height: find all rectangles in the same column/container that need to share the total space
              const sameColumnRects = currentStyle.layout.filter(
                (rect) =>
                  Math.abs(rect.x - rectToUpdate.x) < 0.01 && // Same x position (allowing for floating point precision)
                  rect.totalCols === rectToUpdate.totalCols
              );

              // Calculate total available space (should be 1.0 for the full container)
              const totalAvailableSpace = 1.0;

              // Calculate space used by other rectangles (not the current one or the dependent one)
              let spaceUsedByOthers = 0;
              sameColumnRects.forEach((rect) => {
                if (rect.id !== rectToUpdate.id && rect.id !== depId) {
                  spaceUsedByOthers += rect.height;
                }
              });

              // Calculate remaining space for the dependent rectangle
              const remainingSpace =
                totalAvailableSpace - newValue - spaceUsedByOthers;

              // Ensure dependent rectangle doesn't become too small
              if (remainingSpace > 0.05) {
                // Minimum 5% height
                dependentRect.height = remainingSpace;

                // Update position based on spatial relationship
                if (dependentRect.y > rectToUpdate.y) {
                  // Dependent rect is below - move it down
                  dependentRect.y = rectToUpdate.y + newValue;
                } else if (dependentRect.y < rectToUpdate.y) {
                  // Dependent rect is above - update current rect position
                  rectToUpdate.y = dependentRect.y + dependentRect.height;
                }

                // Handle attached rectangles
                if (
                  dependentRect.controllers &&
                  dependentRect.controllers.attachedHeight
                ) {
                  dependentRect.controllers.attachedHeight.forEach(
                    (attachedId) => {
                      const attachedRect = currentStyle.layout.find(
                        (rect) => rect.id === attachedId
                      );
                      if (attachedRect) {
                        attachedRect.height = dependentRect.height;
                        attachedRect.y = dependentRect.y;
                      }
                    }
                  );
                }
              } else {
                // Revert to previous valid value if it would make the dependent rectangle too small
                input.value = previousValue;
                return;
              }
            } else if (property === "width") {
              // For width: find all rectangles in the same row/container that need to share the total space
              const sameRowRects = currentStyle.layout.filter(
                (rect) =>
                  Math.abs(rect.y - rectToUpdate.y) < 0.01 && // Same y position (allowing for floating point precision)
                  rect.totalRows === rectToUpdate.totalRows
              );

              // Calculate total available space (should be 1.0 for the full container)
              const totalAvailableSpace = 1.0;

              // Calculate space used by other rectangles (not the current one or the dependent one)
              let spaceUsedByOthers = 0;
              sameRowRects.forEach((rect) => {
                if (rect.id !== rectToUpdate.id && rect.id !== depId) {
                  spaceUsedByOthers += rect.width;
                }
              });

              // Calculate remaining space for the dependent rectangle
              const remainingSpace =
                totalAvailableSpace - newValue - spaceUsedByOthers;

              // Ensure dependent rectangle doesn't become too small
              if (remainingSpace > 0.05) {
                // Minimum 5% width
                dependentRect.width = remainingSpace;

                // Update position based on spatial relationship
                if (dependentRect.x > rectToUpdate.x) {
                  // Dependent rect is to the right - move it right
                  dependentRect.x = rectToUpdate.x + newValue;
                } else if (dependentRect.x < rectToUpdate.x) {
                  // Dependent rect is to the left - update current rect position
                  rectToUpdate.x = dependentRect.x + dependentRect.width;
                }

                // Handle attached rectangles
                if (
                  dependentRect.controllers &&
                  dependentRect.controllers.attachedWidth
                ) {
                  dependentRect.controllers.attachedWidth.forEach(
                    (attachedId) => {
                      const attachedRect = currentStyle.layout.find(
                        (rect) => rect.id === attachedId
                      );
                      if (attachedRect) {
                        attachedRect.width = dependentRect.width;
                        attachedRect.x = dependentRect.x;
                      }
                    }
                  );
                }
              } else {
                // Revert to previous valid value if it would make the dependent rectangle too small
                input.value = previousValue;
                return;
              }
            }
          }
        });
      }
    }

    // Handle combinedWidth logic - rectangles that should span multiple other rectangles
    currentStyle.layout.forEach((rect) => {
      if (rect.controllers && rect.controllers.combinedWidth) {
        const sourceRectIds = rect.controllers.combinedWidth;
        if (Array.isArray(sourceRectIds)) {
          // Get source rectangles and sort them by x position
          const sourceRects = sourceRectIds
            .map((id) => currentStyle.layout.find((r) => r.id === id))
            .filter((r) => r)
            .sort((a, b) => a.x - b.x);

          if (sourceRects.length > 0) {
            // Calculate the span from leftmost start to rightmost end
            const leftmostX = sourceRects[0].x;
            const rightmostX =
              sourceRects[sourceRects.length - 1].x +
              sourceRects[sourceRects.length - 1].width;

            // The combined width includes the rectangles AND the gaps between them
            const combinedWidth = rightmostX - leftmostX;

            // Update the rectangle with combined dimensions
            rect.width = combinedWidth;
            rect.x = leftmostX;

            // Update colIndex to match the leftmost source rectangle to avoid double-gap
            // rect.colIndex = sourceRects[0].colIndex;
          }
        }
      }
    });

    // Handle checkWidth triggers - when a rectangle with checkWidth is updated,
    // it should trigger updates to rectangles that depend on it
    if (rectToUpdate.controllers && rectToUpdate.controllers.checkWidth) {
      const checkWidthTargets = rectToUpdate.controllers.checkWidth;
      if (Array.isArray(checkWidthTargets)) {
        checkWidthTargets.forEach((targetId) => {
          const targetRect = currentStyle.layout.find((r) => r.id === targetId);
          if (
            targetRect &&
            targetRect.controllers &&
            targetRect.controllers.combinedWidth
          ) {
            // This will be handled by the combinedWidth logic above
            // No additional action needed here since we process all combinedWidth rectangles
          }
        });
      }
    }

    // Update input values and span values in existing controllers to reflect changes
    currentStyle.layout.forEach((rect) => {
      // Update width inputs for all rectangles that have width controllers
      if (rect.controllers?.width) {
        const widthInput = document.querySelector(
          `input[data-rect-id="${rect.id}"][data-property="width"]`
        );
        if (widthInput && widthInput !== input) {
          // Don't update the input that triggered the change
          const newWidthValue = Math.round(rect.width * CONTAINER_WIDTH_MM);
          widthInput.value = newWidthValue;
          widthInput.dataset.previousValue = newWidthValue.toString();
        }

        // Also update embedded SVG input
        const embeddedWidthInput = document.querySelector(
          `.svg-embedded-input[data-rect-id="${rect.id}"][data-property="width"]`
        );
        if (embeddedWidthInput && embeddedWidthInput !== input) {
          // Don't update the input that triggered the change
          const newWidthValue = Math.round(rect.width * CONTAINER_WIDTH_MM);
          embeddedWidthInput.value = newWidthValue;
          embeddedWidthInput.dataset.previousValue = newWidthValue.toString();
        }
      } else {
        // Update span value for non-controllable width
        const controller = document.querySelector(`#${rect.id}-controller`);
        if (controller) {
          const widthRows = controller.querySelectorAll(
            ".svg-controller-item-inner-bottom-row"
          );
          widthRows.forEach((row) => {
            const label = row.querySelector(
              ".svg-controller-item-inner-bottom-row-label"
            );
            if (label && label.textContent.includes("Width")) {
              const valueSpan = row.querySelector(
                ".svg-controller-item-inner-bottom-row-value"
              );
              if (valueSpan) {
                valueSpan.textContent = Math.round(
                  rect.width * CONTAINER_WIDTH_MM
                );
              }
            }
          });
        }
      }

      // Update height inputs for all rectangles that have height controllers
      if (rect.controllers?.height) {
        const heightInput = document.querySelector(
          `input[data-rect-id="${rect.id}"][data-property="height"]`
        );
        if (heightInput && heightInput !== input) {
          // Don't update the input that triggered the change
          const newHeightValue = Math.round(rect.height * CONTAINER_HEIGHT_MM);
          heightInput.value = newHeightValue;
          heightInput.dataset.previousValue = newHeightValue.toString();
        }

        // Also update embedded SVG input
        const embeddedHeightInput = document.querySelector(
          `.svg-embedded-input[data-rect-id="${rect.id}"][data-property="height"]`
        );
        if (embeddedHeightInput && embeddedHeightInput !== input) {
          // Don't update the input that triggered the change
          const newHeightValue = Math.round(rect.height * CONTAINER_HEIGHT_MM);
          embeddedHeightInput.value = newHeightValue;
          embeddedHeightInput.dataset.previousValue = newHeightValue.toString();
        }
      } else {
        // Update span value for non-controllable height
        const controller = document.querySelector(`#${rect.id}-controller`);
        if (controller) {
          const heightRows = controller.querySelectorAll(
            ".svg-controller-item-inner-bottom-row"
          );
          heightRows.forEach((row) => {
            const label = row.querySelector(
              ".svg-controller-item-inner-bottom-row-label"
            );
            if (label && label.textContent.includes("Height")) {
              const valueSpan = row.querySelector(
                ".svg-controller-item-inner-bottom-row-value"
              );
              if (valueSpan) {
                valueSpan.textContent = Math.round(
                  rect.height * CONTAINER_HEIGHT_MM
                );
              }
            }
          });
        }
      }
    });

    // Check all rectangles for minimum size requirements after dimension changes
    currentStyle.layout.forEach((rect) => {
      if (rect.controllers && rect.controllers.opener) {
        const widthMM = Math.round(rect.width * CONTAINER_WIDTH_MM);
        const heightMM = Math.round(rect.height * CONTAINER_HEIGHT_MM);
        let shouldRevertToFixed = false;
        let errorMessage = "";

        if (rect.controllers.opener === "top-opener") {
          if (widthMM < 350 || heightMM < 400) {
            shouldRevertToFixed = true;
            errorMessage = `Pane ${rect.text}: Top Opener requires minimum 350mm width and 400mm height. Current: ${widthMM}mm x ${heightMM}mm`;
          }
        } else if (rect.controllers.opener === "left-opener") {
          if (widthMM < 500 || heightMM < 400) {
            shouldRevertToFixed = true;
            errorMessage = `Pane ${rect.text}: Left Opener requires minimum 500mm width and 400mm height. Current: ${widthMM}mm x ${heightMM}mm`;
          }
        } else if (rect.controllers.opener === "right-opener") {
          if (widthMM < 500 || heightMM < 400) {
            shouldRevertToFixed = true;
            errorMessage = `Pane ${rect.text}: Right Opener requires minimum 500mm width and 400mm height. Current: ${widthMM}mm x ${heightMM}mm`;
          }
        }

        if (shouldRevertToFixed) {
          this.showErrorPopup(errorMessage, "Opener Size Requirements");
          rect.controllers.opener = "fixed";
          rect.opener = "fixed";

          // Update the embedded SVG select element - uses data-pane-id
          const embeddedSelectElement = document.querySelector(
            `.svg-embedded-select[data-pane-id="${rect.id}"]`
          );
          if (embeddedSelectElement) {
            embeddedSelectElement.value = "fixed";
          }
        }
      }
    });

    // Update the previous value to the new valid value
    input.dataset.previousValue = mmValue.toString();

    // Update SVG attributes instead of regenerating entire SVG
    this.updateSvgElementAttributes(
      this.buyingJourneyObject.panelInfo.styleName
    );
    if (event.isTrusted) {
      input.dispatchEvent(new Event("blur"));
    }
  }

  updateSvgElementAttributes(styleName) {
    const CONTAINER_WIDTH = this.CONTAINER_WIDTH;
    const CONTAINER_HEIGHT = this.CONTAINER_HEIGHT;
    const GAP = this.GAP;
    const style = this.getConfStyle(styleName);
    if (!style) return;

    style.layout.forEach((rect) => {
      const {
        x,
        y,
        width,
        height,
        text,
        totalCols = 1,
        totalRows = 1,
        colIndex = 0,
        rowIndex = 0,
        rowSpan = 0,
        colSpan = 0,
        controllers,
      } = rect;

      const opener = controllers?.opener || "fixed";

      // Calculate absolute dimensions (same logic as createRect)
      const availableWidth = CONTAINER_WIDTH - GAP * (totalCols - colSpan - 1);
      const availableHeight =
        CONTAINER_HEIGHT - GAP * (totalRows - rowSpan - 1);
      const absoluteWidth = width * availableWidth;
      const absoluteHeight = height * availableHeight;
      const absoluteX = x * availableWidth + colIndex * GAP;
      const absoluteY = y * availableHeight + rowIndex * GAP;

      // Calculate dimensions based on opener type
      const isFixed = opener === "fixed";
      const openerWidth = isFixed ? 0 : absoluteWidth;
      const openerHeight = isFixed ? 0 : absoluteHeight;
      const contentWidth = isFixed ? 0 : absoluteWidth - 30;
      const contentHeight = isFixed ? 0 : absoluteHeight - 30;
      const mainRectWidth = isFixed ? absoluteWidth : 0;
      const mainRectHeight = isFixed ? absoluteHeight : 0;
      const mainRectStroke = isFixed ? 2 : 0;

      // Update main rectangle
      const mainRect = document.getElementById(`rect-${text}-main`);
      if (mainRect) {
        mainRect.setAttribute("x", absoluteX);
        mainRect.setAttribute("y", absoluteY);
        mainRect.setAttribute("width", mainRectWidth);
        mainRect.setAttribute("height", mainRectHeight);
        mainRect.setAttribute("stroke-width", mainRectStroke);
      }

      // Update opener rectangle
      const openerRect = document.getElementById(`rect-${text}-opener`);
      if (openerRect) {
        openerRect.setAttribute("x", absoluteX);
        openerRect.setAttribute("y", absoluteY);
        openerRect.setAttribute("width", openerWidth);
        openerRect.setAttribute("height", openerHeight);
        openerRect.setAttribute("stroke-width", isFixed ? 0 : 1);
      }

      // Update content rectangle
      const contentRect = document.getElementById(`rect-${text}`);
      if (contentRect) {
        contentRect.setAttribute("x", absoluteX + 15);
        contentRect.setAttribute("y", absoluteY + 15);
        contentRect.setAttribute("width", contentWidth);
        contentRect.setAttribute("height", contentHeight);
        contentRect.setAttribute("stroke-width", isFixed ? 0 : 1);
      }

      // Update corner lines
      const cornerLines = [
        {
          id: `line-${text}-tl`,
          x1: absoluteX,
          y1: absoluteY,
          x2: absoluteX + 15,
          y2: absoluteY + 15,
        },
        {
          id: `line-${text}-bl`,
          x1: absoluteX,
          y1: absoluteY + absoluteHeight,
          x2: absoluteX + 15,
          y2: absoluteY + absoluteHeight - 15,
        },
        {
          id: `line-${text}-tr`,
          x1: absoluteX + absoluteWidth,
          y1: absoluteY,
          x2: absoluteX + absoluteWidth - 15,
          y2: absoluteY + 15,
        },
        {
          id: `line-${text}-br`,
          x1: absoluteX + absoluteWidth,
          y1: absoluteY + absoluteHeight,
          x2: absoluteX + absoluteWidth - 15,
          y2: absoluteY + absoluteHeight - 15,
        },
      ];

      cornerLines.forEach((line) => {
        const element = document.getElementById(line.id);
        if (element) {
          element.setAttribute("x1", line.x1);
          element.setAttribute("y1", line.y1);
          element.setAttribute("x2", line.x2);
          element.setAttribute("y2", line.y2);
          element.setAttribute("stroke-width", isFixed ? 0 : 1);
        }
      });

      // Update opener direction lines
      const openerLines = [
        // Top opener lines
        {
          id: `line-${text}-opener-1`,
          active: opener === "top-opener",
          x1: absoluteX + 15,
          y1: absoluteY + absoluteHeight - 15,
          x2: absoluteX + absoluteWidth / 2,
          y2: absoluteY + 15,
        },
        {
          id: `line-${text}-opener-2`,
          active: opener === "top-opener",
          x1: absoluteX + absoluteWidth - 15,
          y1: absoluteY + absoluteHeight - 15,
          x2: absoluteX + absoluteWidth / 2,
          y2: absoluteY + 15,
        },
        // Left opener lines
        {
          id: `line-${text}-opener-3`,
          active: opener === "left-opener",
          x1: absoluteX + 15,
          y1: absoluteY + absoluteHeight - 15,
          x2: absoluteX + absoluteWidth - 15,
          y2: absoluteY + absoluteHeight / 2,
        },
        {
          id: `line-${text}-opener-4`,
          active: opener === "left-opener",
          x1: absoluteX + 15,
          y1: absoluteY + 15,
          x2: absoluteX + absoluteWidth - 15,
          y2: absoluteY + absoluteHeight / 2,
        },
        // Right opener lines
        {
          id: `line-${text}-opener-5`,
          active: opener === "right-opener",
          x1: absoluteX + absoluteWidth - 15,
          y1: absoluteY + absoluteHeight - 15,
          x2: absoluteX + 15,
          y2: absoluteY + absoluteHeight / 2,
        },
        {
          id: `line-${text}-opener-6`,
          active: opener === "right-opener",
          x1: absoluteX + absoluteWidth - 15,
          y1: absoluteY + 15,
          x2: absoluteX + 15,
          y2: absoluteY + absoluteHeight / 2,
        },
      ];

      openerLines.forEach((line) => {
        const element = document.getElementById(line.id);
        if (element) {
          if (line.active) {
            element.setAttribute("x1", line.x1);
            element.setAttribute("y1", line.y1);
            element.setAttribute("x2", line.x2);
            element.setAttribute("y2", line.y2);
            element.setAttribute("stroke-width", 3);
          } else {
            element.setAttribute("x1", 0);
            element.setAttribute("y1", 0);
            element.setAttribute("x2", 0);
            element.setAttribute("y2", 0);
            element.setAttribute("stroke-width", 0);
          }
        }
      });

      // Update text position
      const textElement = document.querySelector(`text.rect-text`);
      const textElements = document.querySelectorAll("text.rect-text");
      textElements.forEach((textEl) => {
        if (textEl.textContent === text) {
          textEl.setAttribute("x", absoluteX + absoluteWidth / 2);
          textEl.setAttribute("y", absoluteY + absoluteHeight / 2);
        }
      });

      // Update input controls positions
      if (controllers) {
        const inputWidth = 53;
        const inputHeight = 22;

        if (controllers.width) {
          const widthForeignObject = document.querySelector(
            `foreignObject input[data-rect-id="${text}"][data-property="width"]`
          )?.parentElement;
          if (widthForeignObject) {
            widthForeignObject.setAttribute(
              "x",
              absoluteX + absoluteWidth / 2 - inputWidth / 2
            );
            widthForeignObject.setAttribute("y", this.CONTAINER_HEIGHT + 20);
          }
        }

        if (controllers.height) {
          const heightForeignObject = document.querySelector(
            `foreignObject input[data-rect-id="${text}"][data-property="height"]`
          )?.parentElement;
          if (heightForeignObject) {
            heightForeignObject.setAttribute("x", -60);
            heightForeignObject.setAttribute(
              "y",
              absoluteY + absoluteHeight / 2 - inputHeight / 2
            );
          }
        }
      }
    });
  }

  // disable unfit variants
  disableUnfitVariants() {
    const stylesInputs = document.querySelectorAll(
      'input[name="windows:-style"]'
    );
    const currentWidth = this.CONTAINER_WIDTH_MM;
    const currentHeight = this.CONTAINER_HEIGHT_MM;
    stylesInputs.forEach((input) => {
      const minWidth = input.getAttribute("data-min-width");
      const maxWidth = input.getAttribute("data-max-width");
      const maxHeight = input.getAttribute("data-max-height");
      input.disabled = false;
      if (
        currentWidth < +minWidth ||
        currentWidth > +maxWidth ||
        currentHeight > +maxHeight
      ) {
        input.disabled = true;
        input.checked = false;
      }
    });
  }

  // get the correct product
  getSelectedProduct(styleName, width, height) {
    const productsArrayJSON = document.getElementById(
      "window-styles-products"
    ).textContent;
    const productsArray = JSON.parse(productsArrayJSON);
    // round up the width and height to nearest 100
    const roundedWidth = Math.ceil(width / 100) * 100;
    const roundedHeight = Math.ceil(height / 100) * 100;
    let selectedVariant = null;

    const selectedProduct = productsArray.find((product) => {
      if (product.handle.includes(styleName)) {
        const variants = product.variants;
        const selectedVariantObject = variants.find((variant) => {
          if (
            +variant.options[0] === roundedWidth &&
            +variant.options[1] === roundedHeight
          ) {
            selectedVariant = variant;
            return true;
          }
        });
        return selectedVariantObject;
      }
      return false;
    });

    if (selectedVariant) {
      this.buyingJourneyObject.panelInfo = {
        ...this.buyingJourneyObject.panelInfo,
        price: selectedVariant.price / 100,
        product: selectedProduct,
        variant: selectedVariant,
        image:
          this.buyingJourneyObject.panelInfo.image || selectedVariant.image,
      };
    }
  }

  // get the current style diemssions each panel width and height in mm and the opener type
  getCurrentStyleDimensions() {
    const styleName = this.buyingJourneyObject.panelInfo.styleName;
    const style = this.getConfStyle(styleName);

    // price for opener
    const pricePerLinearMeter = 5; // pounds per linear meter
    const openerFixedPrice = 11; // pounds
    const dummyOpenerFixedPrice = 25; // pounds

    const panels = style.layout.map((rect) => {
      const width = Math.round(rect.width * this.CONTAINER_WIDTH_MM);
      const height = Math.round(rect.height * this.CONTAINER_HEIGHT_MM);
      const linearMeters = ((width + height) * 2) / 1000; // linear meters
      const sqm = (width * height) / 1000000;
      const chosenOpenerFixedPrice =
        rect.controllers?.opener === "dummy"
          ? dummyOpenerFixedPrice
          : openerFixedPrice;
      let price = linearMeters * pricePerLinearMeter + chosenOpenerFixedPrice;
      if (rect.controllers?.opener === "fixed") {
        price = 0;
      }
      return {
        ...rect,
        width_MM: width,
        height_MM: height,
        opener: rect.controllers?.opener || "fixed",
        linearMeters,
        sqm,
        price,
      };
    });

    const totalOpenersCost = panels.reduce(
      (acc, panel) => acc + panel.price,
      0
    );
    const totalLinearMeters = panels.reduce(
      (acc, panel) => acc + panel.linearMeters,
      0
    );
    const totalSqm = panels.reduce((acc, panel) => acc + panel.sqm, 0);
    this.buyingJourneyObject.panelInfo = {
      ...this.buyingJourneyObject.panelInfo,
      panelDimensions: panels,
      summary: {
        totalOpenersCost,
        totalLinearMeters,
        totalSqm,
      },
    };
  }

  editHandler(input, object) {
    const draftOrderId = this.buyingJourney.draftOrderId;
    const stepIndex = input.dataset.stepCount;
    // write an object to the localestoarge
    const editObject = {
      object,
      draftOrderId,
    };
    localStorage.setItem("modified-product", JSON.stringify(editObject));
    window.location.href = `/pages/window-builder?step=${stepIndex}&edit-order=true`;
  }

  preselectOptions() { }

  // Create SVG from panel dimensions data for overview/cart display
  createOverviewSvg(panelInfo, maxWidth = null, maxHeight = null) {
    const GAP = 5; // Gap between panels

    // Set default max dimensions if not provided
    if (!maxWidth) maxWidth = 250;
    if (!maxHeight) maxHeight = 250;

    if (!panelInfo || !panelInfo.panelDimensions) {
      const fallbackWidth = Math.min(200, maxWidth);
      const fallbackHeight = Math.min(200, maxHeight);
      return `<svg width="${fallbackWidth}" height="${fallbackHeight}" viewBox="0 0 ${fallbackWidth} ${fallbackHeight}" style="max-width: 100%; height: auto;"><rect width="100%" height="100%" fill="#f0f0f0" stroke="#ccc" stroke-width="1"/><text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" fill="#666">No Preview</text></svg>`;
    }

    const panels = panelInfo.panelDimensions;

    // Calculate aspect ratio from actual panel dimensions
    const actualWidth = panelInfo.panelWidth;
    const actualHeight = panelInfo.panelHeight;
    const aspectRatio = actualHeight / actualWidth;

    // Calculate optimal dimensions that fit within the container
    let svgWidth = maxWidth;
    let svgHeight = maxWidth * aspectRatio;

    // If height exceeds max, scale down proportionally
    if (svgHeight > maxHeight) {
      svgHeight = maxHeight;
      svgWidth = maxHeight / aspectRatio;
    }

    // Ensure minimum readable size
    const minSize = 120;
    if (svgWidth < minSize && svgHeight < minSize) {
      if (aspectRatio >= 1) {
        svgHeight = minSize;
        svgWidth = minSize / aspectRatio;
      } else {
        svgWidth = minSize;
        svgHeight = minSize * aspectRatio;
      }
    }

    // Round dimensions to avoid sub-pixel issues
    svgWidth = Math.round(svgWidth);
    svgHeight = Math.round(svgHeight);

    let svgContent = `<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" style="max-width: 100%; height: auto; display: block;">`;

    // Create rectangles for each panel
    panels.forEach((panel) => {
      const {
        x,
        y,
        width,
        height,
        text,
        totalCols = 1,
        totalRows = 1,
        colIndex = 0,
        rowIndex = 0,
        rowSpan = 0,
        colSpan = 0,
        opener,
      } = panel;

      // Calculate available space after accounting for gaps
      const availableWidth = svgWidth - GAP * (totalCols - colSpan - 1);
      const availableHeight = svgHeight - GAP * (totalRows - rowSpan - 1);

      // Calculate absolute dimensions
      const absoluteWidth = width * availableWidth;
      const absoluteHeight = height * availableHeight;
      const absoluteX = x * availableWidth + colIndex * GAP;
      const absoluteY = y * availableHeight + rowIndex * GAP;

      // Follow the same style as the main builder
      const isFixed = opener === "fixed";
      const insetSize = Math.min(absoluteWidth, absoluteHeight) * 0.075; // Proportional inset for smaller overview

      if (isFixed) {
        // Fixed panels: single rectangle with black border (like main builder)
        svgContent += `<rect x="${absoluteX}" y="${absoluteY}" width="${absoluteWidth}" height="${absoluteHeight}" 
                              fill="#fffbf3" stroke="#2c3e50" stroke-width="1"/>`;
      } else {
        // Non-fixed panels: white outer rectangle + inner content rectangle + corner lines + opener lines

        // Outer rectangle (white background)
        svgContent += `<rect x="${absoluteX}" y="${absoluteY}" width="${absoluteWidth}" height="${absoluteHeight}" 
                              fill="white" stroke="black" stroke-width="1"/>`;

        // Inner content rectangle
        svgContent += `<rect x="${absoluteX + insetSize}" y="${absoluteY + insetSize
          }" 
                              width="${absoluteWidth - 2 * insetSize
          }" height="${absoluteHeight - 2 * insetSize}" 
                              fill="none" stroke="black" stroke-width="1"/>`;

        // Corner lines connecting outer to inner rectangle
        svgContent += `<line x1="${absoluteX}" y1="${absoluteY}" 
                              x2="${absoluteX + insetSize}" y2="${absoluteY + insetSize
          }" 
                              stroke="black" stroke-width="1"/>`;
        svgContent += `<line x1="${absoluteX}" y1="${absoluteY + absoluteHeight
          }" 
                              x2="${absoluteX + insetSize}" y2="${absoluteY + absoluteHeight - insetSize
          }" 
                              stroke="black" stroke-width="1"/>`;
        svgContent += `<line x1="${absoluteX + absoluteWidth
          }" y1="${absoluteY}" 
                              x2="${absoluteX + absoluteWidth - insetSize
          }" y2="${absoluteY + insetSize}" 
                              stroke="black" stroke-width="1"/>`;
        svgContent += `<line x1="${absoluteX + absoluteWidth}" y1="${absoluteY + absoluteHeight
          }" 
                              x2="${absoluteX + absoluteWidth - insetSize
          }" y2="${absoluteY + absoluteHeight - insetSize}" 
                              stroke="black" stroke-width="1"/>`;

        // Opener direction lines (red, like main builder)
        if (opener === "top-opener") {
          svgContent += `<line x1="${absoluteX + insetSize}" y1="${absoluteY + absoluteHeight - insetSize
            }" 
                                 x2="${absoluteX + absoluteWidth / 2}" y2="${absoluteY + insetSize
            }" 
                                 stroke="red" stroke-width="2"/>`;
          svgContent += `<line x1="${absoluteX + absoluteWidth - insetSize
            }" y1="${absoluteY + absoluteHeight - insetSize}" 
                                 x2="${absoluteX + absoluteWidth / 2}" y2="${absoluteY + insetSize
            }" 
                                 stroke="red" stroke-width="2"/>`;
        } else if (opener === "left-opener") {
          svgContent += `<line x1="${absoluteX + insetSize}" y1="${absoluteY + absoluteHeight - insetSize
            }" 
                                 x2="${absoluteX + absoluteWidth - insetSize
            }" y2="${absoluteY + absoluteHeight / 2}" 
                                 stroke="red" stroke-width="2"/>`;
          svgContent += `<line x1="${absoluteX + insetSize}" y1="${absoluteY + insetSize
            }" 
                                 x2="${absoluteX + absoluteWidth - insetSize
            }" y2="${absoluteY + absoluteHeight / 2}" 
                                 stroke="red" stroke-width="2"/>`;
        } else if (opener === "right-opener") {
          svgContent += `<line x1="${absoluteX + absoluteWidth - insetSize
            }" y1="${absoluteY + absoluteHeight - insetSize}" 
                                 x2="${absoluteX + insetSize}" y2="${absoluteY + absoluteHeight / 2
            }" 
                                 stroke="red" stroke-width="2"/>`;
          svgContent += `<line x1="${absoluteX + absoluteWidth - insetSize
            }" y1="${absoluteY + insetSize}" 
                                 x2="${absoluteX + insetSize}" y2="${absoluteY + absoluteHeight / 2
            }" 
                                 stroke="red" stroke-width="2"/>`;
        }
      }

      // Add panel label
      const textX = absoluteX + absoluteWidth / 2;
      const textY = absoluteY + absoluteHeight / 2;
      svgContent += `<text x="${textX}" y="${textY}" text-anchor="middle" dominant-baseline="middle" 
                             fill="#333" font-size="14" font-weight="bold">${text}</text>`;
    });

    svgContent += "</svg>";
    return svgContent;
  }
}

window.WindowsPanel = WindowsPanel;
